var _inherits = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var JSScratchLink =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/ScratchLink.ts");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./node_modules/process/browser.js":
  /*!*****************************************!*\
    !*** ./node_modules/process/browser.js ***!
    \*****************************************/

  /*! no static exports found */

  /***/
  function node_modulesProcessBrowserJs(module, exports) {
    // shim for using process in browser
    var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;

    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }

    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }

    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }

      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();

    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      } // if setTimeout wasn't available but was latter defined


      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }

      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }

    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      } // if clearTimeout wasn't available but was latter defined


      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }

      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }

    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }

      draining = false;

      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }

      if (queue.length) {
        drainQueue();
      }
    }

    function drainQueue() {
      if (draining) {
        return;
      }

      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
      var len = queue.length;

      while (len) {
        currentQueue = queue;
        queue = [];

        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }

        queueIndex = -1;
        len = queue.length;
      }

      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }

    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);

      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }

      queue.push(new Item(fun, args));

      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    }; // v8 likes predictible objects


    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }

    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };

    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues

    process.versions = {};

    function noop() {}

    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;

    process.listeners = function (name) {
      return [];
    };

    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };

    process.cwd = function () {
      return '/';
    };

    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };

    process.umask = function () {
      return 0;
    };
    /***/

  },

  /***/
  "./node_modules/reflect-metadata/Reflect.js":
  /*!**************************************************!*\
    !*** ./node_modules/reflect-metadata/Reflect.js ***!
    \**************************************************/

  /*! no static exports found */

  /***/
  function node_modulesReflectMetadataReflectJs(module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */
    (function (process, global) {
      /*! *****************************************************************************
      Copyright (C) Microsoft. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      var Reflect;

      (function (Reflect) {
        // Metadata Proposal
        // https://rbuckton.github.io/reflect-metadata/
        (function (factory) {
          var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : Function("return this;")();
          var exporter = makeExporter(Reflect);

          if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
          } else {
            exporter = makeExporter(root.Reflect, exporter);
          }

          factory(exporter);

          function makeExporter(target, previous) {
            return function (key, value) {
              if (typeof target[key] !== "function") {
                Object.defineProperty(target, key, {
                  configurable: true,
                  writable: true,
                  value: value
                });
              }

              if (previous) previous(key, value);
            };
          }
        })(function (exporter) {
          var hasOwn = Object.prototype.hasOwnProperty; // feature test for Symbol support

          var supportsSymbol = typeof Symbol === "function";
          var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
          var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
          var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support

          var supportsProto = {
            __proto__: []
          } instanceof Array; // feature test for __proto__ support

          var downLevel = !supportsCreate && !supportsProto;
          var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate ? function () {
              return MakeDictionary(Object.create(null));
            } : supportsProto ? function () {
              return MakeDictionary({
                __proto__: null
              });
            } : function () {
              return MakeDictionary({});
            },
            has: downLevel ? function (map, key) {
              return hasOwn.call(map, key);
            } : function (map, key) {
              return key in map;
            },
            get: downLevel ? function (map, key) {
              return hasOwn.call(map, key) ? map[key] : undefined;
            } : function (map, key) {
              return map[key];
            }
          }; // Load global or shim versions of Map, Set, and WeakMap

          var functionPrototype = Object.getPrototypeOf(Function);
          var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";

          var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();

          var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();

          var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill(); // [[Metadata]] internal slot
          // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots


          var Metadata = new _WeakMap();
          /**
           * Applies a set of decorators to a property of a target object.
           * @param decorators An array of decorators.
           * @param target The target object.
           * @param propertyKey (Optional) The property key to decorate.
           * @param attributes (Optional) The property descriptor for the target key.
           * @remarks Decorators are applied in reverse order.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     Example = Reflect.decorate(decoratorsArray, Example);
           *
           *     // property (on constructor)
           *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
           *
           *     // property (on prototype)
           *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
           *
           *     // method (on constructor)
           *     Object.defineProperty(Example, "staticMethod",
           *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
           *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
           *
           *     // method (on prototype)
           *     Object.defineProperty(Example.prototype, "method",
           *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
           *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
           *
           */

          function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
              if (!IsArray(decorators)) throw new TypeError();
              if (!IsObject(target)) throw new TypeError();
              if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
              if (IsNull(attributes)) attributes = undefined;
              propertyKey = ToPropertyKey(propertyKey);
              return DecorateProperty(decorators, target, propertyKey, attributes);
            } else {
              if (!IsArray(decorators)) throw new TypeError();
              if (!IsConstructor(target)) throw new TypeError();
              return DecorateConstructor(decorators, target);
            }
          }

          exporter("decorate", decorate); // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
          // https://rbuckton.github.io/reflect-metadata/#reflect.metadata

          /**
           * A default metadata decorator factory that can be used on a class, class member, or parameter.
           * @param metadataKey The key for the metadata entry.
           * @param metadataValue The value for the metadata entry.
           * @returns A decorator function.
           * @remarks
           * If `metadataKey` is already defined for the target and target key, the
           * metadataValue for that key will be overwritten.
           * @example
           *
           *     // constructor
           *     @Reflect.metadata(key, value)
           *     class Example {
           *     }
           *
           *     // property (on constructor, TypeScript only)
           *     class Example {
           *         @Reflect.metadata(key, value)
           *         static staticProperty;
           *     }
           *
           *     // property (on prototype, TypeScript only)
           *     class Example {
           *         @Reflect.metadata(key, value)
           *         property;
           *     }
           *
           *     // method (on constructor)
           *     class Example {
           *         @Reflect.metadata(key, value)
           *         static staticMethod() { }
           *     }
           *
           *     // method (on prototype)
           *     class Example {
           *         @Reflect.metadata(key, value)
           *         method() { }
           *     }
           *
           */

          function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
              if (!IsObject(target)) throw new TypeError();
              if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
              OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }

            return decorator;
          }

          exporter("metadata", metadata);
          /**
           * Define a unique metadata entry on the target.
           * @param metadataKey A key used to store and retrieve metadata.
           * @param metadataValue A value that contains attached metadata.
           * @param target The target object on which to define metadata.
           * @param propertyKey (Optional) The property key for the target.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     Reflect.defineMetadata("custom:annotation", options, Example);
           *
           *     // property (on constructor)
           *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
           *
           *     // property (on prototype)
           *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
           *
           *     // method (on constructor)
           *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
           *
           *     // method (on prototype)
           *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
           *
           *     // decorator factory as metadata-producing annotation.
           *     function MyAnnotation(options): Decorator {
           *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
           *     }
           *
           */

          function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
          }

          exporter("defineMetadata", defineMetadata);
          /**
           * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
           * @param metadataKey A key used to store and retrieve metadata.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.hasMetadata("custom:annotation", Example);
           *
           *     // property (on constructor)
           *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
           *
           */

          function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
          }

          exporter("hasMetadata", hasMetadata);
          /**
           * Gets a value indicating whether the target object has the provided metadata key defined.
           * @param metadataKey A key used to store and retrieve metadata.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
           *
           *     // property (on constructor)
           *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
           *
           */

          function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
          }

          exporter("hasOwnMetadata", hasOwnMetadata);
          /**
           * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
           * @param metadataKey A key used to store and retrieve metadata.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.getMetadata("custom:annotation", Example);
           *
           *     // property (on constructor)
           *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
           *
           */

          function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
          }

          exporter("getMetadata", getMetadata);
          /**
           * Gets the metadata value for the provided metadata key on the target object.
           * @param metadataKey A key used to store and retrieve metadata.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.getOwnMetadata("custom:annotation", Example);
           *
           *     // property (on constructor)
           *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
           *
           */

          function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
          }

          exporter("getOwnMetadata", getOwnMetadata);
          /**
           * Gets the metadata keys defined on the target object or its prototype chain.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns An array of unique metadata keys.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.getMetadataKeys(Example);
           *
           *     // property (on constructor)
           *     result = Reflect.getMetadataKeys(Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.getMetadataKeys(Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.getMetadataKeys(Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.getMetadataKeys(Example.prototype, "method");
           *
           */

          function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
          }

          exporter("getMetadataKeys", getMetadataKeys);
          /**
           * Gets the unique metadata keys defined on the target object.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns An array of unique metadata keys.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.getOwnMetadataKeys(Example);
           *
           *     // property (on constructor)
           *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
           *
           */

          function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
          }

          exporter("getOwnMetadataKeys", getOwnMetadataKeys);
          /**
           * Deletes the metadata entry from the target object with the provided key.
           * @param metadataKey A key used to store and retrieve metadata.
           * @param target The target object on which the metadata is defined.
           * @param propertyKey (Optional) The property key for the target.
           * @returns `true` if the metadata entry was found and deleted; otherwise, false.
           * @example
           *
           *     class Example {
           *         // property declarations are not part of ES6, though they are valid in TypeScript:
           *         // static staticProperty;
           *         // property;
           *
           *         constructor(p) { }
           *         static staticMethod(p) { }
           *         method(p) { }
           *     }
           *
           *     // constructor
           *     result = Reflect.deleteMetadata("custom:annotation", Example);
           *
           *     // property (on constructor)
           *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
           *
           *     // property (on prototype)
           *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
           *
           *     // method (on constructor)
           *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
           *
           *     // method (on prototype)
           *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
           *
           */

          function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey,
            /*Create*/
            false);
            if (IsUndefined(metadataMap)) return false;
            if (!metadataMap.delete(metadataKey)) return false;
            if (metadataMap.size > 0) return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0) return true;
            Metadata.delete(target);
            return true;
          }

          exporter("deleteMetadata", deleteMetadata);

          function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
              var decorator = decorators[i];
              var decorated = decorator(target);

              if (!IsUndefined(decorated) && !IsNull(decorated)) {
                if (!IsConstructor(decorated)) throw new TypeError();
                target = decorated;
              }
            }

            return target;
          }

          function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
              var decorator = decorators[i];
              var decorated = decorator(target, propertyKey, descriptor);

              if (!IsUndefined(decorated) && !IsNull(decorated)) {
                if (!IsObject(decorated)) throw new TypeError();
                descriptor = decorated;
              }
            }

            return descriptor;
          }

          function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);

            if (IsUndefined(targetMetadata)) {
              if (!Create) return undefined;
              targetMetadata = new _Map();
              Metadata.set(O, targetMetadata);
            }

            var metadataMap = targetMetadata.get(P);

            if (IsUndefined(metadataMap)) {
              if (!Create) return undefined;
              metadataMap = new _Map();
              targetMetadata.set(P, metadataMap);
            }

            return metadataMap;
          } // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata


          function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
          } // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata


          function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P,
            /*Create*/
            false);
            if (IsUndefined(metadataMap)) return false;
            return ToBoolean(metadataMap.has(MetadataKey));
          } // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata


          function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
          } // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata


          function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P,
            /*Create*/
            false);
            if (IsUndefined(metadataMap)) return undefined;
            return metadataMap.get(MetadataKey);
          } // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata


          function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P,
            /*Create*/
            true);
            metadataMap.set(MetadataKey, MetadataValue);
          } // 3.1.6.1 OrdinaryMetadataKeys(O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys


          function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null) return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0) return ownKeys;
            if (ownKeys.length <= 0) return parentKeys;
            var set = new _Set();
            var keys = [];

            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
              var key = ownKeys_1[_i];
              var hasKey = set.has(key);

              if (!hasKey) {
                set.add(key);
                keys.push(key);
              }
            }

            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
              var key = parentKeys_1[_a];
              var hasKey = set.has(key);

              if (!hasKey) {
                set.add(key);
                keys.push(key);
              }
            }

            return keys;
          } // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
          // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys


          function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P,
            /*Create*/
            false);
            if (IsUndefined(metadataMap)) return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;

            while (true) {
              var next = IteratorStep(iterator);

              if (!next) {
                keys.length = k;
                return keys;
              }

              var nextValue = IteratorValue(next);

              try {
                keys[k] = nextValue;
              } catch (e) {
                try {
                  IteratorClose(iterator);
                } finally {
                  throw e;
                }
              }

              k++;
            }
          } // 6 ECMAScript Data Typ0es and Values
          // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values


          function Type(x) {
            if (x === null) return 1
            /* Null */
            ;

            switch (typeof x) {
              case "undefined":
                return 0
                /* Undefined */
                ;

              case "boolean":
                return 2
                /* Boolean */
                ;

              case "string":
                return 3
                /* String */
                ;

              case "symbol":
                return 4
                /* Symbol */
                ;

              case "number":
                return 5
                /* Number */
                ;

              case "object":
                return x === null ? 1
                /* Null */
                : 6
                /* Object */
                ;

              default:
                return 6
                /* Object */
                ;
            }
          } // 6.1.1 The Undefined Type
          // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type


          function IsUndefined(x) {
            return x === undefined;
          } // 6.1.2 The Null Type
          // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type


          function IsNull(x) {
            return x === null;
          } // 6.1.5 The Symbol Type
          // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type


          function IsSymbol(x) {
            return typeof x === "symbol";
          } // 6.1.7 The Object Type
          // https://tc39.github.io/ecma262/#sec-object-type


          function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
          } // 7.1 Type Conversion
          // https://tc39.github.io/ecma262/#sec-type-conversion
          // 7.1.1 ToPrimitive(input [, PreferredType])
          // https://tc39.github.io/ecma262/#sec-toprimitive


          function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
              case 0
              /* Undefined */
              :
                return input;

              case 1
              /* Null */
              :
                return input;

              case 2
              /* Boolean */
              :
                return input;

              case 3
              /* String */
              :
                return input;

              case 4
              /* Symbol */
              :
                return input;

              case 5
              /* Number */
              :
                return input;
            }

            var hint = PreferredType === 3
            /* String */
            ? "string" : PreferredType === 5
            /* Number */
            ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);

            if (exoticToPrim !== undefined) {
              var result = exoticToPrim.call(input, hint);
              if (IsObject(result)) throw new TypeError();
              return result;
            }

            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
          } // 7.1.1.1 OrdinaryToPrimitive(O, hint)
          // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive


          function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
              var toString_1 = O.toString;

              if (IsCallable(toString_1)) {
                var result = toString_1.call(O);
                if (!IsObject(result)) return result;
              }

              var valueOf = O.valueOf;

              if (IsCallable(valueOf)) {
                var result = valueOf.call(O);
                if (!IsObject(result)) return result;
              }
            } else {
              var valueOf = O.valueOf;

              if (IsCallable(valueOf)) {
                var result = valueOf.call(O);
                if (!IsObject(result)) return result;
              }

              var toString_2 = O.toString;

              if (IsCallable(toString_2)) {
                var result = toString_2.call(O);
                if (!IsObject(result)) return result;
              }
            }

            throw new TypeError();
          } // 7.1.2 ToBoolean(argument)
          // https://tc39.github.io/ecma262/2016/#sec-toboolean


          function ToBoolean(argument) {
            return !!argument;
          } // 7.1.12 ToString(argument)
          // https://tc39.github.io/ecma262/#sec-tostring


          function ToString(argument) {
            return "" + argument;
          } // 7.1.14 ToPropertyKey(argument)
          // https://tc39.github.io/ecma262/#sec-topropertykey


          function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3
            /* String */
            );
            if (IsSymbol(key)) return key;
            return ToString(key);
          } // 7.2 Testing and Comparison Operations
          // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
          // 7.2.2 IsArray(argument)
          // https://tc39.github.io/ecma262/#sec-isarray


          function IsArray(argument) {
            return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
          } // 7.2.3 IsCallable(argument)
          // https://tc39.github.io/ecma262/#sec-iscallable


          function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
          } // 7.2.4 IsConstructor(argument)
          // https://tc39.github.io/ecma262/#sec-isconstructor


          function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
          } // 7.2.7 IsPropertyKey(argument)
          // https://tc39.github.io/ecma262/#sec-ispropertykey


          function IsPropertyKey(argument) {
            switch (Type(argument)) {
              case 3
              /* String */
              :
                return true;

              case 4
              /* Symbol */
              :
                return true;

              default:
                return false;
            }
          } // 7.3 Operations on Objects
          // https://tc39.github.io/ecma262/#sec-operations-on-objects
          // 7.3.9 GetMethod(V, P)
          // https://tc39.github.io/ecma262/#sec-getmethod


          function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null) return undefined;
            if (!IsCallable(func)) throw new TypeError();
            return func;
          } // 7.4 Operations on Iterator Objects
          // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects


          function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method)) throw new TypeError(); // from Call

            var iterator = method.call(obj);
            if (!IsObject(iterator)) throw new TypeError();
            return iterator;
          } // 7.4.4 IteratorValue(iterResult)
          // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue


          function IteratorValue(iterResult) {
            return iterResult.value;
          } // 7.4.5 IteratorStep(iterator)
          // https://tc39.github.io/ecma262/#sec-iteratorstep


          function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
          } // 7.4.6 IteratorClose(iterator, completion)
          // https://tc39.github.io/ecma262/#sec-iteratorclose


          function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f) f.call(iterator);
          } // 9.1 Ordinary Object Internal Methods and Internal Slots
          // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
          // 9.1.1.1 OrdinaryGetPrototypeOf(O)
          // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof


          function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype) return proto; // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.

            if (proto !== functionPrototype) return proto; // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.

            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype) return proto; // If the constructor was not a function, then we cannot determine the heritage.

            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function") return proto; // If we have some kind of self-reference, then we cannot determine the heritage.

            if (constructor === O) return proto; // we have a pretty good guess at the heritage.

            return constructor;
          } // naive Map shim


          function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];

            var MapIterator =
            /** @class */
            function () {
              function MapIterator(keys, values, selector) {
                this._index = 0;
                this._keys = keys;
                this._values = values;
                this._selector = selector;
              }

              MapIterator.prototype["@@iterator"] = function () {
                return this;
              };

              MapIterator.prototype[iteratorSymbol] = function () {
                return this;
              };

              MapIterator.prototype.next = function () {
                var index = this._index;

                if (index >= 0 && index < this._keys.length) {
                  var result = this._selector(this._keys[index], this._values[index]);

                  if (index + 1 >= this._keys.length) {
                    this._index = -1;
                    this._keys = arraySentinel;
                    this._values = arraySentinel;
                  } else {
                    this._index++;
                  }

                  return {
                    value: result,
                    done: false
                  };
                }

                return {
                  value: undefined,
                  done: true
                };
              };

              MapIterator.prototype.throw = function (error) {
                if (this._index >= 0) {
                  this._index = -1;
                  this._keys = arraySentinel;
                  this._values = arraySentinel;
                }

                throw error;
              };

              MapIterator.prototype.return = function (value) {
                if (this._index >= 0) {
                  this._index = -1;
                  this._keys = arraySentinel;
                  this._values = arraySentinel;
                }

                return {
                  value: value,
                  done: true
                };
              };

              return MapIterator;
            }();

            return (
              /** @class */
              function () {
                function Map() {
                  this._keys = [];
                  this._values = [];
                  this._cacheKey = cacheSentinel;
                  this._cacheIndex = -2;
                }

                Object.defineProperty(Map.prototype, "size", {
                  get: function get() {
                    return this._keys.length;
                  },
                  enumerable: true,
                  configurable: true
                });

                Map.prototype.has = function (key) {
                  return this._find(key,
                  /*insert*/
                  false) >= 0;
                };

                Map.prototype.get = function (key) {
                  var index = this._find(key,
                  /*insert*/
                  false);

                  return index >= 0 ? this._values[index] : undefined;
                };

                Map.prototype.set = function (key, value) {
                  var index = this._find(key,
                  /*insert*/
                  true);

                  this._values[index] = value;
                  return this;
                };

                Map.prototype.delete = function (key) {
                  var index = this._find(key,
                  /*insert*/
                  false);

                  if (index >= 0) {
                    var size = this._keys.length;

                    for (var i = index + 1; i < size; i++) {
                      this._keys[i - 1] = this._keys[i];
                      this._values[i - 1] = this._values[i];
                    }

                    this._keys.length--;
                    this._values.length--;

                    if (key === this._cacheKey) {
                      this._cacheKey = cacheSentinel;
                      this._cacheIndex = -2;
                    }

                    return true;
                  }

                  return false;
                };

                Map.prototype.clear = function () {
                  this._keys.length = 0;
                  this._values.length = 0;
                  this._cacheKey = cacheSentinel;
                  this._cacheIndex = -2;
                };

                Map.prototype.keys = function () {
                  return new MapIterator(this._keys, this._values, getKey);
                };

                Map.prototype.values = function () {
                  return new MapIterator(this._keys, this._values, getValue);
                };

                Map.prototype.entries = function () {
                  return new MapIterator(this._keys, this._values, getEntry);
                };

                Map.prototype["@@iterator"] = function () {
                  return this.entries();
                };

                Map.prototype[iteratorSymbol] = function () {
                  return this.entries();
                };

                Map.prototype._find = function (key, insert) {
                  if (this._cacheKey !== key) {
                    this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                  }

                  if (this._cacheIndex < 0 && insert) {
                    this._cacheIndex = this._keys.length;

                    this._keys.push(key);

                    this._values.push(undefined);
                  }

                  return this._cacheIndex;
                };

                return Map;
              }()
            );

            function getKey(key, _) {
              return key;
            }

            function getValue(_, value) {
              return value;
            }

            function getEntry(key, value) {
              return [key, value];
            }
          } // naive Set shim


          function CreateSetPolyfill() {
            return (
              /** @class */
              function () {
                function Set() {
                  this._map = new _Map();
                }

                Object.defineProperty(Set.prototype, "size", {
                  get: function get() {
                    return this._map.size;
                  },
                  enumerable: true,
                  configurable: true
                });

                Set.prototype.has = function (value) {
                  return this._map.has(value);
                };

                Set.prototype.add = function (value) {
                  return this._map.set(value, value), this;
                };

                Set.prototype.delete = function (value) {
                  return this._map.delete(value);
                };

                Set.prototype.clear = function () {
                  this._map.clear();
                };

                Set.prototype.keys = function () {
                  return this._map.keys();
                };

                Set.prototype.values = function () {
                  return this._map.values();
                };

                Set.prototype.entries = function () {
                  return this._map.entries();
                };

                Set.prototype["@@iterator"] = function () {
                  return this.keys();
                };

                Set.prototype[iteratorSymbol] = function () {
                  return this.keys();
                };

                return Set;
              }()
            );
          } // naive WeakMap shim


          function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return (
              /** @class */
              function () {
                function WeakMap() {
                  this._key = CreateUniqueKey();
                }

                WeakMap.prototype.has = function (target) {
                  var table = GetOrCreateWeakMapTable(target,
                  /*create*/
                  false);
                  return table !== undefined ? HashMap.has(table, this._key) : false;
                };

                WeakMap.prototype.get = function (target) {
                  var table = GetOrCreateWeakMapTable(target,
                  /*create*/
                  false);
                  return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };

                WeakMap.prototype.set = function (target, value) {
                  var table = GetOrCreateWeakMapTable(target,
                  /*create*/
                  true);
                  table[this._key] = value;
                  return this;
                };

                WeakMap.prototype.delete = function (target) {
                  var table = GetOrCreateWeakMapTable(target,
                  /*create*/
                  false);
                  return table !== undefined ? delete table[this._key] : false;
                };

                WeakMap.prototype.clear = function () {
                  // NOTE: not a real clear, just makes the previous data unreachable
                  this._key = CreateUniqueKey();
                };

                return WeakMap;
              }()
            );

            function CreateUniqueKey() {
              var key;

              do {
                key = "@@WeakMap@@" + CreateUUID();
              } while (HashMap.has(keys, key));

              keys[key] = true;
              return key;
            }

            function GetOrCreateWeakMapTable(target, create) {
              if (!hasOwn.call(target, rootKey)) {
                if (!create) return undefined;
                Object.defineProperty(target, rootKey, {
                  value: HashMap.create()
                });
              }

              return target[rootKey];
            }

            function FillRandomBytes(buffer, size) {
              for (var i = 0; i < size; ++i) {
                buffer[i] = Math.random() * 0xff | 0;
              }

              return buffer;
            }

            function GenRandomBytes(size) {
              if (typeof Uint8Array === "function") {
                if (typeof crypto !== "undefined") return crypto.getRandomValues(new Uint8Array(size));
                if (typeof msCrypto !== "undefined") return msCrypto.getRandomValues(new Uint8Array(size));
                return FillRandomBytes(new Uint8Array(size), size);
              }

              return FillRandomBytes(new Array(size), size);
            }

            function CreateUUID() {
              var data = GenRandomBytes(UUID_SIZE); // mark as random - RFC 4122 § 4.4

              data[6] = data[6] & 0x4f | 0x40;
              data[8] = data[8] & 0xbf | 0x80;
              var result = "";

              for (var offset = 0; offset < UUID_SIZE; ++offset) {
                var byte = data[offset];
                if (offset === 4 || offset === 6 || offset === 8) result += "-";
                if (byte < 16) result += "0";
                result += byte.toString(16).toLowerCase();
              }

              return result;
            }
          } // uses a heuristic used by v8 and chakra to force an object into dictionary mode.


          function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
          }
        });
      })(Reflect || (Reflect = {}));
      /* WEBPACK VAR INJECTION */

    }).call(this, __webpack_require__(
    /*! ./../process/browser.js */
    "./node_modules/process/browser.js"), __webpack_require__(
    /*! ./../webpack/buildin/global.js */
    "./node_modules/webpack/buildin/global.js"));
    /***/
  },

  /***/
  "./node_modules/webpack/buildin/global.js":
  /*!***********************************!*\
    !*** (webpack)/buildin/global.js ***!
    \***********************************/

  /*! no static exports found */

  /***/
  function node_modulesWebpackBuildinGlobalJs(module, exports) {
    var g; // This works in non-strict mode

    g = function () {
      return this;
    }();

    try {
      // This works if eval is allowed (see CSP)
      g = g || new Function("return this")();
    } catch (e) {
      // This works if the window reference is available
      if (typeof window === "object") g = window;
    } // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}


    module.exports = g;
    /***/
  },

  /***/
  "./src/BooleanData.ts":
  /*!****************************!*\
    !*** ./src/BooleanData.ts ***!
    \****************************/

  /*! no static exports found */

  /***/
  function srcBooleanDataTs(module, exports, __webpack_require__) {
    "use strict";

    var _exports$EbotBooleanC;

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.EbotBooleanConfig = exports.BooleanHandler = void 0;

    var EventsEbot_1 = __webpack_require__(
    /*! ./EventsEbot */
    "./src/EventsEbot.ts");

    var EbotBooleansEvts = [EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min Off'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max Off'], EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min'], EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min Off'], EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max'], EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max Off'], EventsEbot_1.ScratchLinkEventsEnum['LHS Black'], EventsEbot_1.ScratchLinkEventsEnum['LHS White'], EventsEbot_1.ScratchLinkEventsEnum['RHS Black'], EventsEbot_1.ScratchLinkEventsEnum['RHS White'], EventsEbot_1.ScratchLinkEventsEnum['Proximity Left On'], EventsEbot_1.ScratchLinkEventsEnum['Proximity Right On'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max'], EventsEbot_1.ScratchLinkEventsEnum['Digital 0 On'], EventsEbot_1.ScratchLinkEventsEnum['Digital 0 Off'], EventsEbot_1.ScratchLinkEventsEnum['Digital 1 On'], EventsEbot_1.ScratchLinkEventsEnum['Digital 1 Off']];

    var BooleanHandler = /*#__PURE__*/function () {
      function BooleanHandler(scratchLinkBase) {
        _classCallCheck(this, BooleanHandler);

        this.scratchLinkBase = scratchLinkBase;
        this.init();
      }

      _createClass(BooleanHandler, [{
        key: "init",
        value: function init() {
          var keys = EbotBooleansEvts;

          for (var i = 0; i < keys.length; i++) {
            var evtNo = Number(keys[i]);
            this.setBoolean(evtNo, exports.EbotBooleanConfig[evtNo].default);
          }
        }
      }, {
        key: "handleEvent",
        value: function handleEvent(evtNo) {
          if (this.getBoolean(evtNo) === undefined) return;
          this.setBoolean(evtNo, true);
          var opposites = exports.EbotBooleanConfig[evtNo].opposites;

          for (var i = 0; i < opposites.length; i++) {
            this.setBoolean(opposites[i], false); //console.log(`Event ${opposites[i]} was triggered. New value: ${this.getBoolean(opposites[i])}`)
          } //console.log(`Event ${evtNo} was triggered. New value: ${this.getBoolean(evtNo)}`)

        }
      }, {
        key: "setBoolean",
        value: function setBoolean(evtNo, value) {
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min']) this.scratchLinkBase.sensors.ultra.digital.LHSMin = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max']) this.scratchLinkBase.sensors.ultra.digital.LHSMax = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min']) this.scratchLinkBase.sensors.ultra.digital.RHSMin = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max']) this.scratchLinkBase.sensors.ultra.digital.RHSMax = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min Off']) this.scratchLinkBase.sensors.ultra.digital.LHSMin = !value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max Off']) this.scratchLinkBase.sensors.ultra.digital.LHSMax = !value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min Off']) this.scratchLinkBase.sensors.ultra.digital.RHSMin = !value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max Off']) this.scratchLinkBase.sensors.ultra.digital.RHSMax = !value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Black']) this.scratchLinkBase.sensors.line.digital.LHSBlack = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS White']) this.scratchLinkBase.sensors.line.digital.LHSWhite = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Black']) this.scratchLinkBase.sensors.line.digital.RHSBlack = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS White']) this.scratchLinkBase.sensors.line.digital.RHSWhite = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Proximity Left On']) this.scratchLinkBase.sensors.craneProximity.LHS = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Proximity Right On']) this.scratchLinkBase.sensors.craneProximity.RHS = value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Digital 1 On']) this.scratchLinkBase.sensors.button = !value;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Digital 1 Off']) this.scratchLinkBase.sensors.button = value;
        }
      }, {
        key: "getBoolean",
        value: function getBoolean(evtNo) {
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min']) return this.scratchLinkBase.sensors.ultra.digital.LHSMin;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max']) return this.scratchLinkBase.sensors.ultra.digital.LHSMax;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min']) return this.scratchLinkBase.sensors.ultra.digital.RHSMin;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max']) return this.scratchLinkBase.sensors.ultra.digital.RHSMax;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min Off']) return !this.scratchLinkBase.sensors.ultra.digital.LHSMin;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max Off']) return !this.scratchLinkBase.sensors.ultra.digital.LHSMax;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min Off']) return !this.scratchLinkBase.sensors.ultra.digital.RHSMin;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max Off']) return !this.scratchLinkBase.sensors.ultra.digital.RHSMax;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS Black']) return this.scratchLinkBase.sensors.line.digital.LHSBlack;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['LHS White']) return this.scratchLinkBase.sensors.line.digital.LHSWhite;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS Black']) return this.scratchLinkBase.sensors.line.digital.RHSBlack;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['RHS White']) return this.scratchLinkBase.sensors.line.digital.RHSWhite;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Proximity Left On']) return this.scratchLinkBase.sensors.craneProximity.LHS;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Proximity Right On']) return this.scratchLinkBase.sensors.craneProximity.RHS;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Digital 1 On']) return !this.scratchLinkBase.sensors.button;
          if (evtNo === EventsEbot_1.ScratchLinkEventsEnum['Digital 1 Off']) return this.scratchLinkBase.sensors.button; // If the provided `evtNo` value does not match any of the enum values, return `undefined`.

          return undefined;
        }
      }]);

      return BooleanHandler;
    }();

    exports.BooleanHandler = BooleanHandler;
    exports.EbotBooleanConfig = (_exports$EbotBooleanC = {}, _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Started'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Time LHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Time RHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Distance LHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Distance RHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Ultra'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Colour Change'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Black LHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Black RHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped White LHS'], EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped White RHS'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min Off'], EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max Off'], EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min Off'], EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max Off'], EventsEbot_1.ScratchLinkEventsEnum['Proximity Left Off'], EventsEbot_1.ScratchLinkEventsEnum['Proximity Right Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Time LHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Time RHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Distance LHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Distance RHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Ultra'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Colour Change'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Black LHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped Black RHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped White LHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Wheels Stopped White RHS'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Wheels Started']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['LHS Black'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['LHS White']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RHS Black'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['RHS White']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['LHS White'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['LHS Black']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RHS White'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['RHS Black']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min Off'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Min']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max Off'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['LHS Ultra Max']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min Off'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Min']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max Off'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['RHS Ultra Max']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Proximity Left On'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Proximity Left Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Proximity Left Off'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Proximity Left On']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Proximity Right On'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Proximity Right Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Proximity Right Off'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Proximity Right On']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RFID Read Same'], {
      default: false,
      opposites: []
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['RFID Read Differrent'], {
      default: false,
      opposites: []
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Digital 0 On'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Digital 0 Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Digital 0 Off'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Digital 0 On']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Digital 1 On'], {
      default: true,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Digital 1 Off']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Digital 1 Off'], {
      default: false,
      opposites: [EventsEbot_1.ScratchLinkEventsEnum['Digital 1 On']]
    }), _defineProperty(_exports$EbotBooleanC, EventsEbot_1.ScratchLinkEventsEnum['Matrix Text Finished'], {
      default: true,
      opposites: []
    }), _exports$EbotBooleanC);
    /***/
  },

  /***/
  "./src/Connection.ts":
  /*!***************************!*\
    !*** ./src/Connection.ts ***!
    \***************************/

  /*! no static exports found */

  /***/
  function srcConnectionTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Connection = void 0;

    var ScratchLink_1 = __webpack_require__(
    /*! ./ScratchLink */
    "./src/ScratchLink.ts");

    var EventsEbot_1 = __webpack_require__(
    /*! ./EventsEbot */
    "./src/EventsEbot.ts");

    var BooleanData_1 = __webpack_require__(
    /*! ./BooleanData */
    "./src/BooleanData.ts");

    var Connection = /*#__PURE__*/function () {
      function Connection(scratchLinkBase) {
        _classCallCheck(this, Connection);

        this.scratchLinkBase = scratchLinkBase;
        this.booleanHandler = new BooleanData_1.BooleanHandler(scratchLinkBase);
        this.init();
      }

      _createClass(Connection, [{
        key: "init",
        value: function init() {
          var _this = this;

          ScratchLink_1.browser.onmessage = function (message) {
            var msg = message.data;

            if (msg.type === 'sensorData') {
              Object.assign(_this.scratchLinkBase.sensors.raw, msg.data);

              _this.storeSensorData(msg.data);

              return;
            }

            if (msg.type === 'buttonEvent') {
              _this.scratchLinkBase.eventsEbot.handleButtonPageEvent(msg.data);

              return;
            }

            if (msg.type === 'gamepadEvent') {
              _this.handleGamepadEvent(msg.data);
            }

            if (msg.type === 'gamepadData') {
              _this.handleGamepadData(msg.data);
            }
          };
        }
      }, {
        key: "storeSensorData",
        value: function storeSensorData(dataPacket) {
          if (dataPacket.lgt) {
            this.scratchLinkBase.sensors.line.analog.LHS = dataPacket.lgt[0];
            this.scratchLinkBase.sensors.line.analog.RHS = dataPacket.lgt[1];
          }

          if (dataPacket.Ultras) {
            this.scratchLinkBase.sensors.ultra.analog.LHS = dataPacket.Ultras[0];
            this.scratchLinkBase.sensors.ultra.analog.RHS = dataPacket.Ultras[1];
          }

          if (dataPacket.RGB) {
            this.scratchLinkBase.sensors.colour.red = dataPacket.RGB[0];
            this.scratchLinkBase.sensors.colour.green = dataPacket.RGB[1];
            this.scratchLinkBase.sensors.colour.blue = dataPacket.RGB[2];
            this.scratchLinkBase.sensors.colour.white = dataPacket.RGB[3];
            this.scratchLinkBase.sensors.colour.guess = dataPacket.RGB[5];
            this.scratchLinkBase.sensors.colour.CCT = dataPacket.RGB[4];
          }

          if (dataPacket.VA) {
            this.scratchLinkBase.sensors.power.voltage = dataPacket.VA[0];
            this.scratchLinkBase.sensors.power.current = dataPacket.VA[1];
          }

          if (dataPacket.dst) {
            this.scratchLinkBase.sensors.wheelDistance.LHS = dataPacket.dst[0];
            this.scratchLinkBase.sensors.wheelDistance.RHS = dataPacket.dst[1];
          }

          if (dataPacket.RFID) {
            this.scratchLinkBase.sensors.RFID.tagID = dataPacket.RFID.join(',');
            this.scratchLinkBase.sensors.RFID.tagName = dataPacket.TagName;
          }

          if (dataPacket.evt) {
            this.booleanHandler.handleEvent(dataPacket.evt); //Get all event names that match the event number

            var eventIndexes = []; //

            for (var i = 0; i < Object.values(EventsEbot_1.ScratchLinkEventsEnum).length; i++) {
              if (Object.values(EventsEbot_1.ScratchLinkEventsEnum)[i] === dataPacket.evt) eventIndexes.push(i);
            }

            var eventKeys = Object.keys(EventsEbot_1.ScratchLinkEventsEnum).filter(function (key, index) {
              return eventIndexes.includes(index);
            });

            var _iterator = _createForOfIteratorHelper(eventKeys),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var eventKey = _step.value;
                //@ts-ignore
                this.scratchLinkBase.eventsEbot.dispatchEvent(new Event(eventKey));

                if (eventKey === 'RFID Read Same' || eventKey === 'RFID Read Different') {
                  //@ts-ignore
                  this.scratchLinkBase.eventsEbot.dispatchEvent(new Event('RFID Read'));
                }

                if (eventKey === 'Color Changed') {
                  var colorRaw = this.scratchLinkBase.sensors.raw.Color;
                  var color = colorRaw[0].toUpperCase() + colorRaw.substring(1, colorRaw.length); //@ts-ignore

                  this.scratchLinkBase.eventsEbot.dispatchEvent(new Event("Color ".concat(color)));
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
      }, {
        key: "handleBooleanEvent",
        value: function handleBooleanEvent(evtNo) {}
      }, {
        key: "handleGamepadEvent",
        value: function handleGamepadEvent(dataPacket) {
          if (dataPacket.gamepadNumber === 1) {
            //@ts-ignore
            this.scratchLinkBase.eventsGamepad1.dispatchEvent(new Event(dataPacket.eventName));
          }

          if (dataPacket.gamepadNumber === 2) {
            //@ts-ignore
            this.scratchLinkBase.eventsGamepad2.dispatchEvent(new Event(dataPacket.eventName));
          }
        }
      }, {
        key: "handleGamepadData",
        value: function handleGamepadData(dataPacket) {
          if (dataPacket.gamepadNumber === 1) {
            this.scratchLinkBase.gamepad1 = dataPacket.gamepadPacket.data;
          }

          if (dataPacket.gamepadNumber === 2) {
            this.scratchLinkBase.gamepad2 = dataPacket.gamepadPacket.data;
          }
        }
      }, {
        key: "sendCommand",
        value: function sendCommand(command) {
          ScratchLink_1.browser.postMessage({
            type: 'command',
            data: command
          });
        }
      }]);

      return Connection;
    }();

    exports.Connection = Connection;
    /***/
  },

  /***/
  "./src/Ebot.ts":
  /*!*********************!*\
    !*** ./src/Ebot.ts ***!
    \*********************/

  /*! no static exports found */

  /***/
  function srcEbotTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.ebot_example = exports.ebot_2wd3DOFRFID = exports.ebot_mini_2wd = exports.ebot_2wd = void 0;

    var ScratchLinkBase_1 = __webpack_require__(
    /*! ./ScratchLinkBase */
    "./src/ScratchLinkBase.ts");

    var EbotClasses_1 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_2 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_3 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_4 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_5 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");
    /**
     * Ebot Pro
     */


    var ebot_2wdProperties = (0, ScratchLinkBase_1.getAcceptedScratchLinkPropertiesArray)('forever', 'repeat', 'repeatUntil', 'waitUntil', 'wait', 'stopAll', 'sensors', 'eventsEbot', 'eventsGamepad1', 'eventsGamepad2', 'gamepad1', 'gamepad2');
    var ebot_2wdLedProperties = (0, EbotClasses_1.getAcceptedLedPropertiesArray)('brightness', 'colourRGBCmd', 'colourWordCmd', 'colourHexCmd', 'colourNumberCmd', 'flashCmd', 'offCmd', 'percentCmd', 'shiftCmd', 'pixel', 'ring');
    var ebot_2wdWheelsProperties = (0, EbotClasses_2.getAcceptedWheelsPropertiesArray)('driveDirectionWordCmd', 'driveDirectionDegreesCmd', 'driveRadiusCmd', 'drivePowerCmd', 'stopCmd', 'stopOnBwCmd', 'setUltraEventCmd', 'stopOnUltraCmd', 'stopOnColourCmd', 'resetDistanceCmd');
    var ebot_2wdMatrixProperties = (0, EbotClasses_3.getAcceptedMatrixPropertiesArray)('showMatrixCmd', 'playAnimationCmd', 'rectangleCmd', 'scrollTextCmd', 'brightnessCmd', 'rectangleCmd', 'pointCmd', 'lineCmd', 'moveCmd', 'clearCmd');
    var ebot_2wdCraneProperties = (0, EbotClasses_4.getAcceptedCranePropertiesArray)('presetCmd', 'joint', 'positionCmd');
    var ebot_2wdServoProperties = (0, EbotClasses_5.getAcceptedServoPropertiesArray)('positionCmd', 'servoNo');

    var ebot_2wd = function ebot_2wd() {
      return ScratchLinkBase_1.ScratchLinkBase.init();
    };

    exports.ebot_2wd = ebot_2wd;

    var ebot_mini_2wd = function ebot_mini_2wd() {
      return ScratchLinkBase_1.ScratchLinkBase.init();
    };

    exports.ebot_mini_2wd = ebot_mini_2wd;

    var ebot_2wd3DOFRFID = function ebot_2wd3DOFRFID() {
      return ScratchLinkBase_1.ScratchLinkBase.init();
    };

    exports.ebot_2wd3DOFRFID = ebot_2wd3DOFRFID;

    var ebot_example = function ebot_example() {
      return ScratchLinkBase_1.ScratchLinkBase.init();
    };

    exports.ebot_example = ebot_example;
    /***/
  },

  /***/
  "./src/EbotClasses/EbotCrane.ts":
  /*!**************************************!*\
    !*** ./src/EbotClasses/EbotCrane.ts ***!
    \**************************************/

  /*! no static exports found */

  /***/
  function srcEbotClassesEbotCraneTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    var __param = this && this.__param || function (paramIndex, decorator) {
      return function (target, key) {
        decorator(target, key, paramIndex);
      };
    };

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getAcceptedCranePropertiesArray = exports.EbotCraneClass = void 0;

    var ScratchLink_1 = __webpack_require__(
    /*! ../ScratchLink */
    "./src/ScratchLink.ts");

    var ValidateRangeInt_1 = __webpack_require__(
    /*! ../decorators/ValidateRangeInt */
    "./src/decorators/ValidateRangeInt.ts");

    var RangeParameter_1 = __webpack_require__(
    /*! ../decorators/RangeParameter */
    "./src/decorators/RangeParameter.ts");

    var CraneJointsEnum;

    (function (CraneJointsEnum) {
      CraneJointsEnum["Claw"] = "claw";
      CraneJointsEnum["Wrist Rotate"] = "wrist-rotate";
      CraneJointsEnum["Wrist"] = "wrist";
      CraneJointsEnum["Elbow Rotate"] = "elbow-rotate";
      CraneJointsEnum["Elbow"] = "elbow";
      CraneJointsEnum["Shoulder"] = "shoulder";
      CraneJointsEnum["Base Rotate"] = "base-rotate";
    })(CraneJointsEnum || (CraneJointsEnum = {}));

    ;
    var CranePresetsEnum;

    (function (CranePresetsEnum) {
      CranePresetsEnum["Home"] = "";
      CranePresetsEnum["Flat"] = "";
      CranePresetsEnum["Up"] = "";
      CranePresetsEnum["Down"] = "";
    })(CranePresetsEnum || (CranePresetsEnum = {}));

    var EbotCraneClass = /*#__PURE__*/function () {
      function EbotCraneClass(scratchLinkBase) {
        _classCallCheck(this, EbotCraneClass);

        this.commandType = [];
        this.scratchLinkBase = scratchLinkBase;
        this.checkTooManyCommandsError = this.checkTooManyCommandsError.bind(this);
      }

      _createClass(EbotCraneClass, [{
        key: "sendCommand",
        value: function sendCommand(commandType, command) {
          this.commandType.push(commandType);
          if (this.checkTooManyCommandsError()) return;
          this.scratchLinkBase.connection.sendCommand(command);
          this.resetCraneClass();
          return Promise.resolve();
        }
      }, {
        key: "checkTooManyCommandsError",
        value: function checkTooManyCommandsError() {
          if (this.commandType.length === 1) return false;
          this.scratchLinkBase.printError('Cannot send multiple commands before sending  to the Crane.');
          this.resetCraneClass();
          return true;
        }
      }, {
        key: "resetCraneClass",
        value: function resetCraneClass() {
          this.jointValue = undefined;
          this.commandType = [];
        }
      }, {
        key: "joint",
        value: function joint(_joint) {
          this.jointValue = _joint;
          return this;
        }
      }, {
        key: "positionCmd",
        value: function positionCmd(value) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (this.jointValue) {
                      _context.next = 3;
                      break;
                    }

                    this.scratchLinkBase.printError('Joint was not set before sending setPosition to the crane.');
                    return _context.abrupt("return", Promise.resolve());

                  case 3:
                    this.sendCommand('position', "crane ".concat(CraneJointsEnum[this.jointValue], " ").concat(value, ";"));
                    this.resetCraneClass();
                    return _context.abrupt("return", Promise.resolve());

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
        }
      }, {
        key: "presetCmd",
        value: function presetCmd(preset) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    this.commandType.push('preset');

                    if (!this.checkTooManyCommandsError()) {
                      _context2.next = 3;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 3:
                    ScratchLink_1.browser.postMessage({
                      type: 'sendEbotCranePreset',
                      data: preset
                    });
                    this.resetCraneClass();
                    return _context2.abrupt("return", Promise.resolve());

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));
        }
      }]);

      return EbotCraneClass;
    }();

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], EbotCraneClass.prototype, "positionCmd", null);

    exports.EbotCraneClass = EbotCraneClass;

    var getAcceptedCranePropertiesArray = function getAcceptedCranePropertiesArray() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return args;
    };

    exports.getAcceptedCranePropertiesArray = getAcceptedCranePropertiesArray;
    /***/
  },

  /***/
  "./src/EbotClasses/EbotLed.ts":
  /*!************************************!*\
    !*** ./src/EbotClasses/EbotLed.ts ***!
    \************************************/

  /*! no static exports found */

  /***/
  function srcEbotClassesEbotLedTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    var __param = this && this.__param || function (paramIndex, decorator) {
      return function (target, key) {
        decorator(target, key, paramIndex);
      };
    };

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getAcceptedLedPropertiesArray = exports.EbotLedClass = void 0;

    var wait_1 = __webpack_require__(
    /*! ../utils/wait */
    "./src/utils/wait.ts");

    var ValidateRangeInt_1 = __webpack_require__(
    /*! ../decorators/ValidateRangeInt */
    "./src/decorators/ValidateRangeInt.ts");

    var RangeParameter_1 = __webpack_require__(
    /*! ../decorators/RangeParameter */
    "./src/decorators/RangeParameter.ts");

    var EbotLedClass = /*#__PURE__*/function () {
      function EbotLedClass(scratchLinkBase) {
        _classCallCheck(this, EbotLedClass);

        this.commandType = [];
        this.ScratchLinkBase = scratchLinkBase;
      }

      _createClass(EbotLedClass, [{
        key: "sendCommand",
        value: function sendCommand(commandType, command) {
          this.commandType.push(commandType);
          if (this.checkTooManyCommandsError()) return;
          this.ScratchLinkBase.connection.sendCommand(command);
          this.resetLedClass();
          return Promise.resolve();
        }
      }, {
        key: "resetLedClass",
        value: function resetLedClass() {
          this.ledRingNo = undefined;
          this.pixelValue = undefined;
          this.brightnessValue = undefined;
          this.colorValue = undefined;
          this.commandType = [];
        }
      }, {
        key: "checkTooManyCommandsError",
        value: function checkTooManyCommandsError() {
          if (this.commandType.length === 1) return false;
          this.ScratchLinkBase.printError('Cannot send multiple commands before sending  to the LED.');
          this.resetLedClass();
          return true;
        }
      }, {
        key: "sendColourCommand",
        value: function sendColourCommand() {
          var colorValue = '';

          if (this.colorValue) {
            if (this.colorValue.rgb) colorValue = "(".concat(this.colorValue.rgb[0], ", ").concat(this.colorValue.rgb[1], ", ").concat(this.colorValue.rgb[2], ")");
            if (this.colorValue.hex) colorValue = this.colorValue.hex;
            if (this.colorValue.word) colorValue = this.colorValue.word;
          }

          return this.sendCommand('color', "led".concat(this.ledRingNo || '', " color ").concat(colorValue, " ").concat(this.pixelValue || '', " ").concat(this.brightnessValue || '').trim() + ';');
        }
        /**
         * Flash the led ring
         */

      }, {
        key: "flashCmd",
        value: function flashCmd() {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    this.sendCommand('flash', "led".concat(this.ledRingNo || '', " flash;"));
                    _context3.next = 3;
                    return (0, wait_1.wait)(50);

                  case 3:
                    return _context3.abrupt("return");

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));
        }
        /**
         * Demo the led ring
         */

        /* async demoCmd() {
            return this.sendCommand('demo', `led${this.ledRingNo || ''} demo;`);
        } */

        /**
         * Set what ring to use for the command. If not set, it will use the LHS and RHS rings.
         * @param side 'LHS' | 'RHS' | 'LHS & RHS'
         */

      }, {
        key: "ring",
        value: function ring(side) {
          var num = undefined;
          if (side === 'LHS') num = '1';
          if (side === 'RHS') num = '0';
          this.ledRingNo = num;
          return this;
        }
        /**
         * Set the led pixel range to be used for the command
         * @param startNumber 0-8
         * @param endNumber 0-8 optional
         */

      }, {
        key: "pixel",
        value: function pixel(startNumber, endNumber) {
          if (!endNumber) endNumber = startNumber;
          this.pixelValue = "".concat(startNumber, "-").concat(endNumber);
          return this;
        }
        /**
         * Sets the LED brightness
         * @param brightnessValue 0-100
         */

      }, {
        key: "brightness",
        value: function brightness(brightnessValue) {
          this.brightnessValue = "bright ".concat(brightnessValue);
          return this;
        }
        /**
         * Set's the colour of the LED Rings on the robot as RGB values
         * @example
         * eBot.led.colorRGB(100, 0, 0).
         * @param red - Red colour 0-100
         * @param green - Green colour 0-100
         * @param blue  - Green colour 0-100
         */

      }, {
        key: "colourRGBCmd",
        value: function colourRGBCmd(red, green, blue) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    this.colorValue = {
                      rgb: [red, green, blue]
                    };
                    return _context4.abrupt("return", this.sendColourCommand());

                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));
        }
        /**
         * Set's the colour of the LEDs on the robot as a word
         * @param color - The colour to set the LEDs to
         */

      }, {
        key: "colourWordCmd",
        value: function colourWordCmd(color) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    this.colorValue = {
                      word: color
                    };
                    return _context5.abrupt("return", this.sendColourCommand());

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));
        }
        /**
         * Set's the colour of the LEDs on the robot as a hex value
         * @param color - The colour to set the LEDs to
         * @example
         * led.colourHexCmd('#FFFF');
         */

      }, {
        key: "colourHexCmd",
        value: function colourHexCmd(color) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    this.colorValue = {
                      hex: color
                    };
                    return _context6.abrupt("return", this.sendColourCommand());

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));
        }
      }, {
        key: "colourNumberCmd",
        value: function colourNumberCmd(color) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
            var decimalToHex, rgbToDecimal, hsvToRgb, hexColor;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    decimalToHex = function decimalToHex(decimal) {
                      if (decimal < 0) {
                        decimal += 0xFFFFFF + 1;
                      }

                      var hex = Number(decimal).toString(16);
                      hex = "#".concat('000000'.substr(0, 6 - hex.length)).concat(hex);
                      return hex;
                    };

                    rgbToDecimal = function rgbToDecimal(rgb) {
                      return (rgb.r << 16) + (rgb.g << 8) + rgb.b;
                    };

                    hsvToRgb = function hsvToRgb(hsv) {
                      var h = hsv.h % 360;
                      if (h < 0) h += 360;
                      var s = Math.max(0, Math.min(hsv.s, 1));
                      var v = Math.max(0, Math.min(hsv.v, 1));
                      var i = Math.floor(h / 60);
                      var f = h / 60 - i;
                      var p = v * (1 - s);
                      var q = v * (1 - s * f);
                      var t = v * (1 - s * (1 - f));
                      var r;
                      var g;
                      var b;

                      switch (i) {
                        default:
                        case 0:
                          r = v;
                          g = t;
                          b = p;
                          break;

                        case 1:
                          r = q;
                          g = v;
                          b = p;
                          break;

                        case 2:
                          r = p;
                          g = v;
                          b = t;
                          break;

                        case 3:
                          r = p;
                          g = q;
                          b = v;
                          break;

                        case 4:
                          r = t;
                          g = p;
                          b = v;
                          break;

                        case 5:
                          r = v;
                          g = p;
                          b = q;
                          break;
                      }

                      return {
                        r: Math.floor(r * 255),
                        g: Math.floor(g * 255),
                        b: Math.floor(b * 255)
                      };
                    };

                    hexColor = decimalToHex(rgbToDecimal(hsvToRgb({
                      h: color * 360 / 100,
                      s: 100,
                      v: 100
                    })));
                    if (color === 0) hexColor = '#000000';
                    if (color === 100) hexColor = '#FFFFFF';
                    this.colorValue = {
                      hex: hexColor
                    };
                    return _context7.abrupt("return", this.sendColourCommand());

                  case 8:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));
        }
        /**
         * Shifts the LEDs up or down
         * @param direction - The direction to shift the LEDs
         */

      }, {
        key: "shiftCmd",
        value: function shiftCmd(direction, amount) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    return _context8.abrupt("return", this.sendCommand('shift', "led".concat(this.ledRingNo || '', " shift ").concat(direction, " ").concat(amount ? Math.round(amount) : undefined || '', ";")));

                  case 1:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));
        }
        /**
         * Sets the LED brightness as a percentage of the current brightness
         * @param percent - The percentage to set the brightness to
         */

      }, {
        key: "percentCmd",
        value: function percentCmd(percent) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    return _context9.abrupt("return", this.sendCommand('percent', "led".concat(this.ledRingNo || '', " percent ").concat(percent, ";")));

                  case 1:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          }));
        }
        /**
         * Turns the LED off
         */

      }, {
        key: "offCmd",
        value: function offCmd() {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    return _context10.abrupt("return", this.sendCommand('off', "led".concat(this.ledRingNo || '', " off ").concat(this.pixelValue || '', ";")));

                  case 1:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10, this);
          }));
        }
      }]);

      return EbotLedClass;
    }();

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 8)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 8)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", void 0)], EbotLedClass.prototype, "pixel", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", void 0)], EbotLedClass.prototype, "brightness", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 100)), __param(2, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number, Number]), __metadata("design:returntype", Promise)], EbotLedClass.prototype, "colourRGBCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], EbotLedClass.prototype, "colourNumberCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], EbotLedClass.prototype, "percentCmd", null);

    exports.EbotLedClass = EbotLedClass;

    var getAcceptedLedPropertiesArray = function getAcceptedLedPropertiesArray() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return args;
    };

    exports.getAcceptedLedPropertiesArray = getAcceptedLedPropertiesArray;
    /***/
  },

  /***/
  "./src/EbotClasses/EbotMatrix.ts":
  /*!***************************************!*\
    !*** ./src/EbotClasses/EbotMatrix.ts ***!
    \***************************************/

  /*! no static exports found */

  /***/
  function srcEbotClassesEbotMatrixTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    var __param = this && this.__param || function (paramIndex, decorator) {
      return function (target, key) {
        decorator(target, key, paramIndex);
      };
    };

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getAcceptedMatrixPropertiesArray = exports.EbotMatrixClass = exports.EbotMatrixAnimationEnum = exports.EbotMatrixesEnum = void 0;

    var ScratchLink_1 = __webpack_require__(
    /*! ../ScratchLink */
    "./src/ScratchLink.ts");

    var ValidateRangeInt_1 = __webpack_require__(
    /*! ../decorators/ValidateRangeInt */
    "./src/decorators/ValidateRangeInt.ts");

    var RangeParameter_1 = __webpack_require__(
    /*! ../decorators/RangeParameter */
    "./src/decorators/RangeParameter.ts");

    var EbotMatrixesEnum;

    (function (EbotMatrixesEnum) {
      EbotMatrixesEnum["debugMatrix"] = "ff8080808080808080808080808080ffff0101010101010101010101010101ff";
    })(EbotMatrixesEnum = exports.EbotMatrixesEnum || (exports.EbotMatrixesEnum = {}));

    var EbotMatrixAnimationEnum;

    (function (EbotMatrixAnimationEnum) {
      EbotMatrixAnimationEnum["debugAnimation"] = "";
    })(EbotMatrixAnimationEnum = exports.EbotMatrixAnimationEnum || (exports.EbotMatrixAnimationEnum = {}));

    var EbotMatrixClass = /*#__PURE__*/function () {
      function EbotMatrixClass(scratchLinkBase) {
        _classCallCheck(this, EbotMatrixClass);

        this.commandType = [];
        this.scratchLinkBase = scratchLinkBase;
      }

      _createClass(EbotMatrixClass, [{
        key: "resetMatrixClass",
        value: function resetMatrixClass() {
          this.commandType = [];
        }
      }, {
        key: "checkTooManyCommandsError",
        value: function checkTooManyCommandsError() {
          if (this.commandType.length === 1) return false;
          this.scratchLinkBase.printError('Cannot send multiple commands before sending  to the Matrix.');
          this.resetMatrixClass();
          return true;
        }
      }, {
        key: "sendCommand",
        value: function sendCommand(commandType, command) {
          this.commandType.push(commandType);
          if (this.checkTooManyCommandsError()) return;
          this.scratchLinkBase.connection.sendCommand(command);
          this.resetMatrixClass();
        }
        /**
         * Set a matrix on the device by name
         * @param matrix - Matrix Name
         */

      }, {
        key: "showMatrixCmd",
        value: function showMatrixCmd(matrix) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    this.commandType.push('matrix');

                    if (!this.checkTooManyCommandsError()) {
                      _context11.next = 3;
                      break;
                    }

                    return _context11.abrupt("return");

                  case 3:
                    if (this.scratchLinkBase.envIsNode) this.scratchLinkBase.connection.sendCommand("matrix show 0x".concat(EbotMatrixesEnum[matrix], ";"));else ScratchLink_1.browser.postMessage({
                      type: 'displayMatrix',
                      data: matrix
                    });
                    this.resetMatrixClass();
                    return _context11.abrupt("return", Promise.resolve());

                  case 6:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11, this);
          }));
        }
      }, {
        key: "playAnimationCmd",
        value: function playAnimationCmd(animation) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
            return _regeneratorRuntime.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    this.commandType.push('animation');

                    if (!this.checkTooManyCommandsError()) {
                      _context12.next = 3;
                      break;
                    }

                    return _context12.abrupt("return");

                  case 3:
                    ScratchLink_1.browser.postMessage({
                      type: 'displayMatrixAnimation',
                      data: animation
                    });
                    this.resetMatrixClass();
                    return _context12.abrupt("return", Promise.resolve());

                  case 6:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12, this);
          }));
        }
        /**
         * Display scrolling text on the matrix
         * @param text - Text to display
         * @param speed - Speed of the scrolling text. Can be either 'slow', 'medium', 'fast' or a number in milliseconds
         */

      }, {
        key: "scrollTextCmd",
        value: function scrollTextCmd(text, speed) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
            return _regeneratorRuntime.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return this.clearCmd();

                  case 2:
                    return _context13.abrupt("return", this.sendCommand('text', "matrix text ".concat(speed, " '").concat(text, "';")));

                  case 3:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13, this);
          }));
        }
      }, {
        key: "brightnessCmd",
        value: function brightnessCmd(brightness) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
            return _regeneratorRuntime.wrap(function _callee14$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    return _context14.abrupt("return", this.sendCommand('brightness', "matrix bright ".concat(brightness, ";")));

                  case 1:
                  case "end":
                    return _context14.stop();
                }
              }
            }, _callee14, this);
          }));
        }
      }, {
        key: "rectangleCmd",
        value: function rectangleCmd(x1, y1, x2, y2, fill) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
            return _regeneratorRuntime.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    return _context15.abrupt("return", this.sendCommand('rectangle', "matrix rectangle ".concat(x1, " ").concat(y1, " ").concat(x2, " ").concat(y2, " ").concat(fill, ";")));

                  case 1:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15, this);
          }));
        }
      }, {
        key: "pointCmd",
        value: function pointCmd(x, y, fill) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
            return _regeneratorRuntime.wrap(function _callee16$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    return _context16.abrupt("return", this.sendCommand('point', "matrix point ".concat(x, " ").concat(y, " ").concat(fill, ";")));

                  case 1:
                  case "end":
                    return _context16.stop();
                }
              }
            }, _callee16, this);
          }));
        }
      }, {
        key: "lineCmd",
        value: function lineCmd(x1, y1, x2, y2) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
            return _regeneratorRuntime.wrap(function _callee17$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                    return _context17.abrupt("return", this.sendCommand('line', "matrix line ".concat(x1, " ").concat(y1, " ").concat(x2, " ").concat(y2, ";")));

                  case 1:
                  case "end":
                    return _context17.stop();
                }
              }
            }, _callee17, this);
          }));
        }
      }, {
        key: "moveCmd",
        value: function moveCmd(direction) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
            return _regeneratorRuntime.wrap(function _callee18$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    return _context18.abrupt("return", this.sendCommand('move', "matrix ".concat(direction, ";")));

                  case 1:
                  case "end":
                    return _context18.stop();
                }
              }
            }, _callee18, this);
          }));
        }
      }, {
        key: "clearCmd",
        value: function clearCmd() {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
            return _regeneratorRuntime.wrap(function _callee19$(_context19) {
              while (1) {
                switch (_context19.prev = _context19.next) {
                  case 0:
                    return _context19.abrupt("return", this.sendCommand('clear', "matrix clear;"));

                  case 1:
                  case "end":
                    return _context19.stop();
                }
              }
            }, _callee19, this);
          }));
        }
      }]);

      return EbotMatrixClass;
    }();

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], EbotMatrixClass.prototype, "brightnessCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(2, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(3, (0, RangeParameter_1.RangeParameter)(0, 16)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number, Number, Number, String]), __metadata("design:returntype", Promise)], EbotMatrixClass.prototype, "rectangleCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 16)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number, String]), __metadata("design:returntype", Promise)], EbotMatrixClass.prototype, "pointCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(2, (0, RangeParameter_1.RangeParameter)(0, 16)), __param(3, (0, RangeParameter_1.RangeParameter)(0, 16)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number, Number, Number]), __metadata("design:returntype", Promise)], EbotMatrixClass.prototype, "lineCmd", null);

    exports.EbotMatrixClass = EbotMatrixClass;

    var getAcceptedMatrixPropertiesArray = function getAcceptedMatrixPropertiesArray() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return args;
    };

    exports.getAcceptedMatrixPropertiesArray = getAcceptedMatrixPropertiesArray;
    /***/
  },

  /***/
  "./src/EbotClasses/EbotServo.ts":
  /*!**************************************!*\
    !*** ./src/EbotClasses/EbotServo.ts ***!
    \**************************************/

  /*! no static exports found */

  /***/
  function srcEbotClassesEbotServoTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    var __param = this && this.__param || function (paramIndex, decorator) {
      return function (target, key) {
        decorator(target, key, paramIndex);
      };
    };

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getAcceptedServoPropertiesArray = exports.EbotServoClass = void 0;

    var ValidateRangeInt_1 = __webpack_require__(
    /*! ../decorators/ValidateRangeInt */
    "./src/decorators/ValidateRangeInt.ts");

    var RangeParameter_1 = __webpack_require__(
    /*! ../decorators/RangeParameter */
    "./src/decorators/RangeParameter.ts");

    var EbotServoClass = /*#__PURE__*/function () {
      function EbotServoClass(scratchLinkBase) {
        _classCallCheck(this, EbotServoClass);

        this.ScratchLinkBase = scratchLinkBase;
      }

      _createClass(EbotServoClass, [{
        key: "resetServoClass",
        value: function resetServoClass() {
          this.servoNoValue = undefined;
        }
      }, {
        key: "servoNo",
        value: function servoNo(_servoNo) {
          this.servoNoValue = _servoNo;
          return this;
        }
      }, {
        key: "positionCmd",
        value: function positionCmd(value) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
            return _regeneratorRuntime.wrap(function _callee20$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    if (this.servoNoValue === undefined) this.ScratchLinkBase.connection.sendCommand("servo ".concat(value, ";"));else this.ScratchLinkBase.connection.sendCommand("servo".concat(this.servoNoValue, " ").concat(value, ";"));
                    this.resetServoClass();
                    return _context20.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context20.stop();
                }
              }
            }, _callee20, this);
          }));
        }
      }]);

      return EbotServoClass;
    }();

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], EbotServoClass.prototype, "positionCmd", null);

    exports.EbotServoClass = EbotServoClass;

    var getAcceptedServoPropertiesArray = function getAcceptedServoPropertiesArray() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return args;
    };

    exports.getAcceptedServoPropertiesArray = getAcceptedServoPropertiesArray;
    /***/
  },

  /***/
  "./src/EbotClasses/EbotWheels.ts":
  /*!***************************************!*\
    !*** ./src/EbotClasses/EbotWheels.ts ***!
    \***************************************/

  /*! no static exports found */

  /***/
  function srcEbotClassesEbotWheelsTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    var __param = this && this.__param || function (paramIndex, decorator) {
      return function (target, key) {
        decorator(target, key, paramIndex);
      };
    };

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getAcceptedWheelsPropertiesArray = exports.EbotWheelsClass = void 0;

    var ValidateRangeInt_1 = __webpack_require__(
    /*! ../decorators/ValidateRangeInt */
    "./src/decorators/ValidateRangeInt.ts");

    var RangeParameter_1 = __webpack_require__(
    /*! ../decorators/RangeParameter */
    "./src/decorators/RangeParameter.ts");

    var WheelsDirectionEnum;

    (function (WheelsDirectionEnum) {
      WheelsDirectionEnum["Forward"] = "f";
      WheelsDirectionEnum["Right Turn"] = "rt";
      WheelsDirectionEnum["Left Turn"] = "lt";
      WheelsDirectionEnum["Hard Right Turn"] = "hrt";
      WheelsDirectionEnum["Hard Left Turn"] = "hlt";
      WheelsDirectionEnum["Backwards"] = "b";
    })(WheelsDirectionEnum || (WheelsDirectionEnum = {}));

    ;
    var WheelsDirectionOmniEnum;

    (function (WheelsDirectionOmniEnum) {
      WheelsDirectionOmniEnum["Forward"] = "f";
      WheelsDirectionOmniEnum["Right Turn"] = "rt";
      WheelsDirectionOmniEnum["Left Turn"] = "lt";
      WheelsDirectionOmniEnum["Hard Right Turn"] = "hrt";
      WheelsDirectionOmniEnum["Hard Left Turn"] = "hlt";
      WheelsDirectionOmniEnum["Backwards"] = "b";
      WheelsDirectionOmniEnum["Left Diagonal"] = "ld";
      WheelsDirectionOmniEnum["Right Diagonal"] = "rd";
      WheelsDirectionOmniEnum["Left Shift"] = "ls";
      WheelsDirectionOmniEnum["Right Shift"] = "rs";
    })(WheelsDirectionOmniEnum || (WheelsDirectionOmniEnum = {}));

    var EbotWheelsClass = /*#__PURE__*/function () {
      function EbotWheelsClass(scratchLinkBase) {
        _classCallCheck(this, EbotWheelsClass);

        this.ScratchLinkBase = scratchLinkBase;
      }

      _createClass(EbotWheelsClass, [{
        key: "resetWheelsClass",
        value: function resetWheelsClass() {}
      }, {
        key: "driveDirectionWordCmd",
        value: function driveDirectionWordCmd(direction, power) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    this.ScratchLinkBase.connection.sendCommand("wheels drive ".concat(WheelsDirectionEnum[direction], " ").concat(power, ";"));
                    this.resetWheelsClass();
                    return _context21.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee21, this);
          }));
        }
      }, {
        key: "driveDirectionDegreesCmd",
        value: function driveDirectionDegreesCmd(angle, power) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
            var directionInRadians, joyX, joyY, left, right;
            return _regeneratorRuntime.wrap(function _callee22$(_context22) {
              while (1) {
                switch (_context22.prev = _context22.next) {
                  case 0:
                    if (angle < 0) angle = 180 + (180 - Math.abs(angle));
                    directionInRadians = angle * (Math.PI / 180); // Calculate the x and y coordinates using direction and distance (power)

                    joyX = power * Math.sin(directionInRadians);
                    joyY = power * Math.cos(directionInRadians);
                    left = power;
                    right = power;

                    if (joyX <= 0 && joyY >= 0) {
                      //Top Left
                      left = power + joyX;
                    }

                    if (joyX > 0 && joyY >= 0) {
                      //Top Right
                      right = power - joyX;
                    }

                    if (joyX < 0 && joyY < 0) {
                      //Bottom Left
                      left = joyY;
                    }

                    if (joyX > 0 && joyY < 0) {
                      //Bottom Right
                      right = joyY;
                    }

                    if (joyX > -15 && joyX < 15 && joyY < 0) {
                      //Direct Bottom
                      left = -power;
                      right = -power;
                    } //Round to integers


                    left = Math.round(left);
                    right = Math.round(right);
                    this.ScratchLinkBase.connection.sendCommand("wheels power ".concat(left, " ").concat(right, ";"));
                    this.resetWheelsClass();
                    return _context22.abrupt("return", Promise.resolve());

                  case 16:
                  case "end":
                    return _context22.stop();
                }
              }
            }, _callee22, this);
          }));
        }
      }, {
        key: "driveRadiusCmd",
        value: function driveRadiusCmd(radius, degrees, power, brake) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
            return _regeneratorRuntime.wrap(function _callee23$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    this.ScratchLinkBase.connection.sendCommand("wheels circle ".concat(degrees, " ").concat(radius, " ").concat(power, " ").concat(brake === 'brake' ? 'on' : 'off', ";"));
                    this.resetWheelsClass();
                    return _context23.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context23.stop();
                }
              }
            }, _callee23, this);
          }));
        }
      }, {
        key: "drivePowerCmd",
        value: function drivePowerCmd(lhs, rhs) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
            return _regeneratorRuntime.wrap(function _callee24$(_context24) {
              while (1) {
                switch (_context24.prev = _context24.next) {
                  case 0:
                    this.ScratchLinkBase.connection.sendCommand("wheels power ".concat(lhs, " ").concat(rhs, ";"));
                    this.resetWheelsClass();
                    return _context24.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context24.stop();
                }
              }
            }, _callee24, this);
          }));
        }
      }, {
        key: "stopCmd",
        value: function stopCmd(brake) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
            return _regeneratorRuntime.wrap(function _callee25$(_context25) {
              while (1) {
                switch (_context25.prev = _context25.next) {
                  case 0:
                    this.ScratchLinkBase.connection.sendCommand("wheels off ".concat(brake, ";"));
                    this.resetWheelsClass();
                    return _context25.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context25.stop();
                }
              }
            }, _callee25, this);
          }));
        }
      }, {
        key: "stopOnBwCmd",
        value: function stopOnBwCmd(onOff, colour, side) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
            var sideStr;
            return _regeneratorRuntime.wrap(function _callee26$(_context26) {
              while (1) {
                switch (_context26.prev = _context26.next) {
                  case 0:
                    sideStr = '';
                    if (side === 'LHS') sideStr = '0';
                    if (side === 'RHS') sideStr = '1';
                    this.ScratchLinkBase.connection.sendCommand("bw stop ".concat(onOff, " ").concat(colour, " ").concat(sideStr, ";"));
                    this.resetWheelsClass();
                    return _context26.abrupt("return", Promise.resolve());

                  case 6:
                  case "end":
                    return _context26.stop();
                }
              }
            }, _callee26, this);
          }));
        }
      }, {
        key: "setUltraEventCmd",
        value: function setUltraEventCmd(side, minMax, distance) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
            var sideStr;
            return _regeneratorRuntime.wrap(function _callee27$(_context27) {
              while (1) {
                switch (_context27.prev = _context27.next) {
                  case 0:
                    sideStr = '';
                    if (side === 'LHS') sideStr = '0';
                    if (side === 'RHS') sideStr = '1';
                    this.ScratchLinkBase.connection.sendCommand("ultra".concat(sideStr, " ").concat(minMax, " ").concat(distance, ";"));
                    this.resetWheelsClass();
                    return _context27.abrupt("return", Promise.resolve());

                  case 6:
                  case "end":
                    return _context27.stop();
                }
              }
            }, _callee27, this);
          }));
        }
      }, {
        key: "stopOnUltraCmd",
        value: function stopOnUltraCmd(onOff, minMax, side) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
            var sideStr;
            return _regeneratorRuntime.wrap(function _callee28$(_context28) {
              while (1) {
                switch (_context28.prev = _context28.next) {
                  case 0:
                    sideStr = side ? this.getNoFromSide(side) : '';
                    this.ScratchLinkBase.connection.sendCommand("ultra".concat(sideStr, " stop ").concat(minMax, " ").concat(onOff, ";"));
                    this.resetWheelsClass();
                    return _context28.abrupt("return", Promise.resolve());

                  case 4:
                  case "end":
                    return _context28.stop();
                }
              }
            }, _callee28, this);
          }));
        }
      }, {
        key: "stopOnColourCmd",
        value: function stopOnColourCmd(colour) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
            return _regeneratorRuntime.wrap(function _callee29$(_context29) {
              while (1) {
                switch (_context29.prev = _context29.next) {
                  case 0:
                    this.ScratchLinkBase.connection.sendCommand("color stop ".concat(colour, ";"));
                    this.resetWheelsClass();
                    return _context29.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context29.stop();
                }
              }
            }, _callee29, this);
          }));
        }
      }, {
        key: "resetDistanceCmd",
        value: function resetDistanceCmd() {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
            return _regeneratorRuntime.wrap(function _callee30$(_context30) {
              while (1) {
                switch (_context30.prev = _context30.next) {
                  case 0:
                    this.ScratchLinkBase.connection.sendCommand("wheels zero;");
                    this.resetWheelsClass();
                    return _context30.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context30.stop();
                }
              }
            }, _callee30, this);
          }));
        }
      }, {
        key: "getNoFromSide",
        value: function getNoFromSide(side) {
          if (side === 'LHS') return '0';
          if (side === 'RHS') return '1';
          return '';
        }
      }]);

      return EbotWheelsClass;
    }();

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(1, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [String, Number]), __metadata("design:returntype", Promise)], EbotWheelsClass.prototype, "driveDirectionWordCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 360)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", Promise)], EbotWheelsClass.prototype, "driveDirectionDegreesCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(1, (0, RangeParameter_1.RangeParameter)(0, 360)), __param(2, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number, Number, String]), __metadata("design:returntype", Promise)], EbotWheelsClass.prototype, "driveRadiusCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(0, (0, RangeParameter_1.RangeParameter)(0, 100)), __param(1, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", Promise)], EbotWheelsClass.prototype, "drivePowerCmd", null);

    __decorate([ValidateRangeInt_1.ValidateRangeInt, __param(2, (0, RangeParameter_1.RangeParameter)(0, 100)), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String, Number]), __metadata("design:returntype", Promise)], EbotWheelsClass.prototype, "setUltraEventCmd", null);

    exports.EbotWheelsClass = EbotWheelsClass;

    var getAcceptedWheelsPropertiesArray = function getAcceptedWheelsPropertiesArray() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return args;
    };

    exports.getAcceptedWheelsPropertiesArray = getAcceptedWheelsPropertiesArray;
    /***/
  },

  /***/
  "./src/EbotClasses/index.ts":
  /*!**********************************!*\
    !*** ./src/EbotClasses/index.ts ***!
    \**********************************/

  /*! no static exports found */

  /***/
  function srcEbotClassesIndexTs(module, exports, __webpack_require__) {
    "use strict";

    var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);

      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
          enumerable: true,
          get: function get() {
            return m[k];
          }
        };
      }

      Object.defineProperty(o, k2, desc);
    } : function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      o[k2] = m[k];
    });

    var __exportStar = this && this.__exportStar || function (m, exports) {
      for (var p in m) {
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
      }
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    __exportStar(__webpack_require__(
    /*! ./EbotLed */
    "./src/EbotClasses/EbotLed.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./EbotMatrix */
    "./src/EbotClasses/EbotMatrix.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./EbotWheels */
    "./src/EbotClasses/EbotWheels.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./EbotCrane */
    "./src/EbotClasses/EbotCrane.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./EbotServo */
    "./src/EbotClasses/EbotServo.ts"), exports);
    /***/

  },

  /***/
  "./src/EventsEbot.ts":
  /*!***************************!*\
    !*** ./src/EventsEbot.ts ***!
    \***************************/

  /*! no static exports found */

  /***/
  function srcEventsEbotTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.ScratchLinkEventTarget = exports.ScratchLinkEventsEnum = void 0;

    var decorators_1 = __webpack_require__(
    /*! ./decorators */
    "./src/decorators/index.ts");

    var ScratchLinkBase_1 = __webpack_require__(
    /*! ./ScratchLinkBase */
    "./src/ScratchLinkBase.ts");

    var ScratchLinkEventsEnum;

    (function (ScratchLinkEventsEnum) {
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Started"] = 1] = "Wheels Started";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped"] = 2] = "Wheels Stopped";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Time LHS"] = 3] = "Wheels Stopped Time LHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Time RHS"] = 4] = "Wheels Stopped Time RHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Distance LHS"] = 5] = "Wheels Stopped Distance LHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Distance RHS"] = 6] = "Wheels Stopped Distance RHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Ultra"] = 20] = "Wheels Stopped Ultra";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Colour Change"] = 41] = "Wheels Stopped Colour Change";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Black LHS"] = 7] = "Wheels Stopped Black LHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped Black RHS"] = 8] = "Wheels Stopped Black RHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped White LHS"] = 9] = "Wheels Stopped White LHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Wheels Stopped White RHS"] = 10] = "Wheels Stopped White RHS";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["LHS Black"] = 11] = "LHS Black";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RHS Black"] = 12] = "RHS Black";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["LHS White"] = 13] = "LHS White";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RHS White"] = 14] = "RHS White";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["LHS Ultra Min"] = 23] = "LHS Ultra Min";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["LHS Ultra Min Off"] = 24] = "LHS Ultra Min Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["LHS Ultra Max"] = 25] = "LHS Ultra Max";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["LHS Ultra Max Off"] = 26] = "LHS Ultra Max Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RHS Ultra Min"] = 27] = "RHS Ultra Min";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RHS Ultra Min Off"] = 28] = "RHS Ultra Min Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RHS Ultra Max"] = 29] = "RHS Ultra Max";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RHS Ultra Max Off"] = 30] = "RHS Ultra Max Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Proximity Left On"] = 44] = "Proximity Left On";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Proximity Left Off"] = 45] = "Proximity Left Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Proximity Right On"] = 46] = "Proximity Right On";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Proximity Right Off"] = 47] = "Proximity Right Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RFID Read Same"] = 54] = "RFID Read Same";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RFID Read Differrent"] = 55] = "RFID Read Differrent";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Digital 0 On"] = 61] = "Digital 0 On";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Digital 0 Off"] = 62] = "Digital 0 Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Digital 1 On"] = 63] = "Digital 1 On";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Digital 1 Off"] = 64] = "Digital 1 Off";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Matrix Text Finished"] = 17] = "Matrix Text Finished";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Changed"] = 40] = "Color Changed";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color None"] = 0] = "Color None";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color White"] = 0] = "Color White";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Red"] = 0] = "Color Red";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Green"] = 0] = "Color Green";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Blue"] = 0] = "Color Blue";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Black"] = 0] = "Color Black";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Yellow"] = 0] = "Color Yellow";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Color Tan"] = 0] = "Color Tan";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["RFID Read"] = 0] = "RFID Read";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Matrix Animation Finished"] = 43] = "Matrix Animation Finished";
      ScratchLinkEventsEnum[ScratchLinkEventsEnum["Button"] = 64] = "Button";
    })(ScratchLinkEventsEnum = exports.ScratchLinkEventsEnum || (exports.ScratchLinkEventsEnum = {}));

    ;

    var ScratchLinkEventTarget = /*#__PURE__*/function (_EventTarget) {
      _inherits(ScratchLinkEventTarget, _EventTarget);

      var _super = _createSuper(ScratchLinkEventTarget);

      function ScratchLinkEventTarget(scratchLinkBase) {
        var _this2;

        _classCallCheck(this, ScratchLinkEventTarget);

        _this2 = _super.call(this);
        _this2.ScratchLinkBase = scratchLinkBase;
        return _this2;
      }

      _createClass(ScratchLinkEventTarget, [{
        key: "handleButtonPageEvent",
        value: function handleButtonPageEvent(buttonName) {
          this.dispatchEvent(new Event(buttonName));
        }
      }]);

      return ScratchLinkEventTarget;
    }( /*#__PURE__*/_wrapNativeSuper(EventTarget));

    __decorate([(0, decorators_1.enumerable)(false), __metadata("design:type", ScratchLinkBase_1.ScratchLinkBase)], ScratchLinkEventTarget.prototype, "ScratchLinkBase", void 0);

    exports.ScratchLinkEventTarget = ScratchLinkEventTarget;
    /***/
  },

  /***/
  "./src/GamepadEvents.ts":
  /*!******************************!*\
    !*** ./src/GamepadEvents.ts ***!
    \******************************/

  /*! no static exports found */

  /***/
  function srcGamepadEventsTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.ScratchLinkGamepadEventTarget = exports.GamepadEventsEnum = void 0;

    var decorators_1 = __webpack_require__(
    /*! ./decorators */
    "./src/decorators/index.ts");

    var ScratchLinkBase_1 = __webpack_require__(
    /*! ./ScratchLinkBase */
    "./src/ScratchLinkBase.ts");

    var GamepadEventsEnum;

    (function (GamepadEventsEnum) {})(GamepadEventsEnum = exports.GamepadEventsEnum || (exports.GamepadEventsEnum = {}));

    ;

    var ScratchLinkGamepadEventTarget = /*#__PURE__*/function (_EventTarget2) {
      _inherits(ScratchLinkGamepadEventTarget, _EventTarget2);

      var _super2 = _createSuper(ScratchLinkGamepadEventTarget);

      function ScratchLinkGamepadEventTarget(scratchLinkBase) {
        var _this3;

        _classCallCheck(this, ScratchLinkGamepadEventTarget);

        _this3 = _super2.call(this);
        _this3.ScratchLinkBase = scratchLinkBase;
        return _this3;
      }

      return ScratchLinkGamepadEventTarget;
    }( /*#__PURE__*/_wrapNativeSuper(EventTarget));

    __decorate([(0, decorators_1.enumerable)(false), __metadata("design:type", ScratchLinkBase_1.ScratchLinkBase)], ScratchLinkGamepadEventTarget.prototype, "ScratchLinkBase", void 0);

    exports.ScratchLinkGamepadEventTarget = ScratchLinkGamepadEventTarget;
    /***/
  },

  /***/
  "./src/Javascript.ts":
  /*!***************************!*\
    !*** ./src/Javascript.ts ***!
    \***************************/

  /*! no static exports found */

  /***/
  function srcJavascriptTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.javascript = void 0;

    var ScratchLinkBase_1 = __webpack_require__(
    /*! ./ScratchLinkBase */
    "./src/ScratchLinkBase.ts");
    /**
     * Javascript Pro Beginner
     */


    var javascriptProperties = (0, ScratchLinkBase_1.getAcceptedScratchLinkPropertiesArray)('forever', 'repeat', 'waitUntil', 'wait', 'eventsGamepad1', 'eventsGamepad2', 'gamepad1', 'gamepad2', 'stopAll', 'repeat', 'stopAll', 'forever');

    var javascript = function javascript() {
      return ScratchLinkBase_1.ScratchLinkBase.init();
    };

    exports.javascript = javascript;
    /***/
  },

  /***/
  "./src/ScratchLink.ts":
  /*!****************************!*\
    !*** ./src/ScratchLink.ts ***!
    \****************************/

  /*! no static exports found */

  /***/
  function srcScratchLinkTs(module, exports, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */

    (function (global) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.window = exports.browser = void 0;

      var utils_1 = __webpack_require__(
      /*! ./utils */
      "./src/utils/index.ts");

      var Ebot_1 = __webpack_require__(
      /*! ./Ebot */
      "./src/Ebot.ts");

      var Javascript_1 = __webpack_require__(
      /*! ./Javascript */
      "./src/Javascript.ts");

      if ((0, utils_1.isNodeJs)()) {
        //@ts-ignore
        global.self = {};
      }

      exports.browser = self;
      exports.window = self;
      var JSScratchLink = {
        ebot_2wd: Ebot_1.ebot_2wd,
        ebot_mini_2wd: Ebot_1.ebot_mini_2wd,
        ebot_2wd3DOFRFID: Ebot_1.ebot_2wd3DOFRFID,
        ebot_example: Ebot_1.ebot_example,
        javascript: Javascript_1.javascript
      };
      exports.default = JSScratchLink;
      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__(
    /*! ./../node_modules/webpack/buildin/global.js */
    "./node_modules/webpack/buildin/global.js"));
    /***/
  },

  /***/
  "./src/ScratchLinkBase.ts":
  /*!********************************!*\
    !*** ./src/ScratchLinkBase.ts ***!
    \********************************/

  /*! no static exports found */

  /***/
  function srcScratchLinkBaseTs(module, exports, __webpack_require__) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
      var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    var __metadata = this && this.__metadata || function (k, v) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.getAcceptedScratchLinkPropertiesArray = exports.ScratchLinkBase = exports.printError = exports.postMessage = void 0;

    var decorators_1 = __webpack_require__(
    /*! ./decorators */
    "./src/decorators/index.ts");

    var Connection_1 = __webpack_require__(
    /*! ./Connection */
    "./src/Connection.ts");

    var utils_1 = __webpack_require__(
    /*! ./utils */
    "./src/utils/index.ts");

    var EbotClasses_1 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_2 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_3 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_4 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EbotClasses_5 = __webpack_require__(
    /*! ./EbotClasses */
    "./src/EbotClasses/index.ts");

    var EventsEbot_1 = __webpack_require__(
    /*! ./EventsEbot */
    "./src/EventsEbot.ts");

    var GamepadEvents_1 = __webpack_require__(
    /*! ./GamepadEvents */
    "./src/GamepadEvents.ts");

    var ScratchLink_1 = __webpack_require__(
    /*! ./ScratchLink */
    "./src/ScratchLink.ts");

    var utils_2 = __webpack_require__(
    /*! ./utils */
    "./src/utils/index.ts");

    var ScratchLinkTimer = /*#__PURE__*/function () {
      function ScratchLinkTimer() {
        _classCallCheck(this, ScratchLinkTimer);

        this._startTime = 0;
        this.reset();
      }

      _createClass(ScratchLinkTimer, [{
        key: "getTime",
        value: function getTime() {
          var time = (new Date().getTime() - this._startTime) / 1000;
          return Number(time.toFixed(1));
        }
      }, {
        key: "reset",
        value: function reset() {
          this._startTime = new Date().getTime();
        }
      }]);

      return ScratchLinkTimer;
    }();

    var postMessage = function postMessage(message) {
      if (ScratchLink_1.window !== undefined && ScratchLink_1.window.parent) return ScratchLink_1.window.parent.postMessage(message, '*');
      return ScratchLink_1.browser.postMessage(message);
    };

    exports.postMessage = postMessage;

    var printError = function printError(msg) {
      var packet = {
        type: 'logLibError',
        data: {
          msg: msg
        }
      };
      (0, exports.postMessage)(packet);
      return Promise.resolve();
    };

    exports.printError = printError;
    /**
     * SET OF RLES FOR CREATING COMMAND CLASSES
     *
     * 1. All commands should use a common term so its evident that the same term cannot be used in a command sequence twice. There will also be runtime checking for clashes where a term is used twice.
     * 2. All parameters should be able to be chained together with their own function. This will allow for a more fluent syntax.
     * 3. All common command pramaters have their own function to be chained like led.brightness()
     */

    var ScratchLinkBase = /*#__PURE__*/function () {
      function ScratchLinkBase() {
        _classCallCheck(this, ScratchLinkBase);

        this.timer = ScratchLinkTimer;
        this.sensors = {
          ultra: {
            analog: {},
            digital: {}
          },
          line: {
            analog: {},
            digital: {}
          },
          craneProximity: {},
          colour: {},
          RFID: {},
          wheelDistance: {},
          power: {},
          raw: {}
        };
        this.gamepad1 = {};
        this.gamepad2 = {};
        this.envIsNode = (0, utils_1.isNodeJs)();
        this.connection = new Connection_1.Connection(this);
        this.led = new EbotClasses_1.EbotLedClass(this);
        this.wheels = new EbotClasses_2.EbotWheelsClass(this);
        this.matrix = new EbotClasses_3.EbotMatrixClass(this);
        this.crane = new EbotClasses_4.EbotCraneClass(this);
        this.servo = new EbotClasses_5.EbotServoClass(this); //@ts-ignore

        this.eventsEbot = new EventsEbot_1.ScratchLinkEventTarget(this); //@ts-ignore

        this.eventsGamepad1 = new GamepadEvents_1.ScratchLinkGamepadEventTarget(this); //@ts-ignore

        this.eventsGamepad2 = new GamepadEvents_1.ScratchLinkGamepadEventTarget(this);
        this.stopAll = this.stopAll.bind(this);
        this.print = this.print.bind(this);
        this.printError = this.printError.bind(this);
      }
      /**
       * Wait for a certain number of seconds
       * @param time - time in seconds
       */


      _createClass(ScratchLinkBase, [{
        key: "wait",
        value: function wait(time) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
            return _regeneratorRuntime.wrap(function _callee31$(_context31) {
              while (1) {
                switch (_context31.prev = _context31.next) {
                  case 0:
                    return _context31.abrupt("return", new Promise(function (resolve) {
                      setTimeout(function () {
                        resolve();
                      }, time * 1000);
                    }));

                  case 1:
                  case "end":
                    return _context31.stop();
                }
              }
            }, _callee31);
          }));
        }
      }, {
        key: "postMessage",
        value: function postMessage(message) {
          (0, exports.postMessage)(message);
        }
      }, {
        key: "printError",
        value: function printError(msg) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
            return _regeneratorRuntime.wrap(function _callee32$(_context32) {
              while (1) {
                switch (_context32.prev = _context32.next) {
                  case 0:
                    return _context32.abrupt("return", (0, exports.printError)(msg));

                  case 1:
                  case "end":
                    return _context32.stop();
                }
              }
            }, _callee32);
          }));
        }
        /**
         * Print out a message to the console
         * @param message - The message to print
         */

      }, {
        key: "print",
        value: function print(message) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
            var msg, packet;
            return _regeneratorRuntime.wrap(function _callee33$(_context33) {
              while (1) {
                switch (_context33.prev = _context33.next) {
                  case 0:
                    if (!(typeof Worker === "undefined")) {
                      _context33.next = 2;
                      break;
                    }

                    return _context33.abrupt("return", console.log(message));

                  case 2:
                    msg = typeof message === 'string' || typeof message === 'number' ? message : JSON.stringify(message);
                    packet = {
                      type: 'log',
                      data: {
                        msg: msg
                      }
                    };
                    this.postMessage(packet);

                  case 5:
                  case "end":
                    return _context33.stop();
                }
              }
            }, _callee33, this);
          }));
        }
        /**
         * Forever loop
         * @param loopFunction
         */

      }, {
        key: "forever",
        value: function forever(loopFunction) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
            var _this4 = this;

            var loop;
            return _regeneratorRuntime.wrap(function _callee35$(_context35) {
              while (1) {
                switch (_context35.prev = _context35.next) {
                  case 0:
                    loop = function loop() {
                      return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
                        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                          while (1) {
                            switch (_context34.prev = _context34.next) {
                              case 0:
                                _context34.next = 2;
                                return loopFunction();

                              case 2:
                                setTimeout(function () {
                                  return loop();
                                }, 1000 / 30); //Run 30 times a second so it doesnt block the main thread message listener stopping it from getting messages

                              case 3:
                              case "end":
                                return _context34.stop();
                            }
                          }
                        }, _callee34);
                      }));
                    };

                    loop();

                  case 2:
                  case "end":
                    return _context35.stop();
                }
              }
            }, _callee35);
          }));
        }
      }, {
        key: "repeat",
        value: function repeat(_repeat, loopFunction) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
            var _this5 = this;

            var i, repeatLoop;
            return _regeneratorRuntime.wrap(function _callee37$(_context37) {
              while (1) {
                switch (_context37.prev = _context37.next) {
                  case 0:
                    i = 0;

                    repeatLoop = function repeatLoop() {
                      return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
                        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                          while (1) {
                            switch (_context36.prev = _context36.next) {
                              case 0:
                                _context36.next = 2;
                                return loopFunction();

                              case 2:
                                _context36.next = 4;
                                return (0, utils_2.wait)(1000 / 30);

                              case 4:
                                i++;

                                if (!(i < _repeat)) {
                                  _context36.next = 8;
                                  break;
                                }

                                _context36.next = 8;
                                return repeatLoop();

                              case 8:
                              case "end":
                                return _context36.stop();
                            }
                          }
                        }, _callee36);
                      }));
                    };

                    _context37.next = 4;
                    return repeatLoop();

                  case 4:
                  case "end":
                    return _context37.stop();
                }
              }
            }, _callee37);
          }));
        }
        /**
         *
         * @param conditionFunc - function that returns true when the loop should end
         * @param loopFunction - function that runs every loop
         * @returns
         * @example
         * control.repeatUntil(function() {
         *      return eBot.sensors.button
         *   }, function() {
         *      led.flashCmd()
         *      control.wait(0.3)
         *   })
         */

      }, {
        key: "repeatUntil",
        value: function repeatUntil(conditionFunc, loopFunction) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
            var _this6 = this;

            return _regeneratorRuntime.wrap(function _callee40$(_context40) {
              while (1) {
                switch (_context40.prev = _context40.next) {
                  case 0:
                    return _context40.abrupt("return", new Promise(function (resolve) {
                      return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
                        var _this7 = this;

                        var loop;
                        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                          while (1) {
                            switch (_context39.prev = _context39.next) {
                              case 0:
                                loop = function loop() {
                                  return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
                                    var shouldEnd;
                                    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
                                      while (1) {
                                        switch (_context38.prev = _context38.next) {
                                          case 0:
                                            _context38.next = 2;
                                            return loopFunction();

                                          case 2:
                                            shouldEnd = false;

                                            if (!(typeof conditionFunc() === 'object' && typeof conditionFunc().then === 'function')) {
                                              _context38.next = 9;
                                              break;
                                            }

                                            _context38.next = 6;
                                            return conditionFunc();

                                          case 6:
                                            shouldEnd = _context38.sent;
                                            _context38.next = 10;
                                            break;

                                          case 9:
                                            //promise func
                                            shouldEnd = conditionFunc();

                                          case 10:
                                            if (!shouldEnd) {
                                              _context38.next = 12;
                                              break;
                                            }

                                            return _context38.abrupt("return", resolve());

                                          case 12:
                                            setTimeout(function () {
                                              return loop();
                                            }, 1000 / 30); //Run 30 times a second so it doesnt block the main thread message listener stopping it from getting messages

                                          case 13:
                                          case "end":
                                            return _context38.stop();
                                        }
                                      }
                                    }, _callee38);
                                  }));
                                };

                                loop();

                              case 2:
                              case "end":
                                return _context39.stop();
                            }
                          }
                        }, _callee39);
                      }));
                    }));

                  case 1:
                  case "end":
                    return _context40.stop();
                }
              }
            }, _callee40);
          }));
        }
      }, {
        key: "waitUntil",
        value: function waitUntil(conditionFunc) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
            var _this8 = this;

            return _regeneratorRuntime.wrap(function _callee43$(_context43) {
              while (1) {
                switch (_context43.prev = _context43.next) {
                  case 0:
                    return _context43.abrupt("return", new Promise(function (resolve) {
                      return __awaiter(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
                        var _this9 = this;

                        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                          while (1) {
                            switch (_context42.prev = _context42.next) {
                              case 0:
                                setInterval(function () {
                                  return __awaiter(_this9, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
                                    var shouldEnd;
                                    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
                                      while (1) {
                                        switch (_context41.prev = _context41.next) {
                                          case 0:
                                            shouldEnd = false;

                                            if (!(typeof conditionFunc() === 'object' && typeof conditionFunc().then === 'function')) {
                                              _context41.next = 7;
                                              break;
                                            }

                                            _context41.next = 4;
                                            return conditionFunc();

                                          case 4:
                                            shouldEnd = !_context41.sent;
                                            _context41.next = 8;
                                            break;

                                          case 7:
                                            //promise func
                                            shouldEnd = !conditionFunc();

                                          case 8:
                                            if (!shouldEnd) {
                                              _context41.next = 10;
                                              break;
                                            }

                                            return _context41.abrupt("return");

                                          case 10:
                                            resolve();

                                          case 11:
                                          case "end":
                                            return _context41.stop();
                                        }
                                      }
                                    }, _callee41);
                                  }));
                                }, 5);

                              case 1:
                              case "end":
                                return _context42.stop();
                            }
                          }
                        }, _callee42);
                      }));
                    }));

                  case 1:
                  case "end":
                    return _context43.stop();
                }
              }
            }, _callee43);
          }));
        }
      }, {
        key: "stream",
        value: function stream(on) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
            return _regeneratorRuntime.wrap(function _callee44$(_context44) {
              while (1) {
                switch (_context44.prev = _context44.next) {
                  case 0:
                    this.connection.sendCommand("stream on ".concat(on ? 'on' : 'off', ";"));
                    return _context44.abrupt("return", Promise.resolve());

                  case 2:
                  case "end":
                    return _context44.stop();
                }
              }
            }, _callee44, this);
          }));
        }
      }, {
        key: "ping",
        value: function ping() {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
            return _regeneratorRuntime.wrap(function _callee45$(_context45) {
              while (1) {
                switch (_context45.prev = _context45.next) {
                  case 0:
                    this.connection.sendCommand("ping;");
                    return _context45.abrupt("return", Promise.resolve());

                  case 2:
                  case "end":
                    return _context45.stop();
                }
              }
            }, _callee45, this);
          }));
        }
      }, {
        key: "stopAll",
        value: function stopAll() {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
            var packet;
            return _regeneratorRuntime.wrap(function _callee46$(_context46) {
              while (1) {
                switch (_context46.prev = _context46.next) {
                  case 0:
                    packet = {
                      type: 'status',
                      data: 'ended'
                    };
                    this.postMessage(packet);
                    return _context46.abrupt("return", Promise.resolve());

                  case 3:
                  case "end":
                    return _context46.stop();
                }
              }
            }, _callee46, this);
          }));
        }
      }], [{
        key: "init",
        value: function init() {
          return new this();
        }
      }]);

      return ScratchLinkBase;
    }();

    __decorate([(0, decorators_1.enumerable)(false), __metadata("design:type", Boolean)], ScratchLinkBase.prototype, "envIsNode", void 0);

    exports.ScratchLinkBase = ScratchLinkBase;

    var getAcceptedScratchLinkPropertiesArray = function getAcceptedScratchLinkPropertiesArray() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return args;
    };

    exports.getAcceptedScratchLinkPropertiesArray = getAcceptedScratchLinkPropertiesArray;
    /***/
  },

  /***/
  "./src/decorators/RangeParameter.ts":
  /*!******************************************!*\
    !*** ./src/decorators/RangeParameter.ts ***!
    \******************************************/

  /*! no static exports found */

  /***/
  function srcDecoratorsRangeParameterTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.RangeParameter = void 0;

    __webpack_require__(
    /*! reflect-metadata */
    "./node_modules/reflect-metadata/Reflect.js");

    var constants_1 = __webpack_require__(
    /*! ./constants */
    "./src/decorators/constants.ts");

    function RangeParameter() {
      var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      return function (target, propertyKey, parameterIndex) {
        // Pull existing metadata (if any)
        var existingRanges = Reflect.getMetadata(constants_1.RANGE_KEY, target, propertyKey) || {}; // Add new value

        existingRanges[parameterIndex] = [min, max]; // Store metadata

        Reflect.defineMetadata(constants_1.RANGE_KEY, existingRanges, target, propertyKey);
      };
    }

    exports.RangeParameter = RangeParameter;
    /***/
  },

  /***/
  "./src/decorators/ValidateRangeInt.ts":
  /*!********************************************!*\
    !*** ./src/decorators/ValidateRangeInt.ts ***!
    \********************************************/

  /*! no static exports found */

  /***/
  function srcDecoratorsValidateRangeIntTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.ValidateRangeInt = void 0;

    __webpack_require__(
    /*! reflect-metadata */
    "./node_modules/reflect-metadata/Reflect.js");

    var constants_1 = __webpack_require__(
    /*! ./constants */
    "./src/decorators/constants.ts");

    var ScratchLinkBase_1 = __webpack_require__(
    /*! ../ScratchLinkBase */
    "./src/ScratchLinkBase.ts");

    function ValidateRangeInt(target, propertyKey, descriptor) {
      // Store the original value
      var savedValue = descriptor.value; // Attach validation logic

      descriptor.value = function () {
        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }

        // Pull the active ranges (if any)
        var monitoredRanges = Reflect.getOwnMetadata(constants_1.RANGE_KEY, target, propertyKey) || {}; // Check all monitored ranges
        // tslint:disable-next-line:forin

        for (var key in Reflect.ownKeys(monitoredRanges)) {
          var range = monitoredRanges[key];
          var value = args[key]; // Throw error if outside range

          if (value < range[0] || value > range[1]) (0, ScratchLinkBase_1.printError)("".concat(value, " is outside of range ").concat(range[0], "-").concat(range[1], " for function ").concat(String(propertyKey)));
        } //Round all numbers to integers


        args = args.map(function (arg) {
          if (typeof arg === 'number') return Math.round(arg);
          return arg;
        });
        return savedValue.apply(this, args);
      };
    }

    exports.ValidateRangeInt = ValidateRangeInt;
    /***/
  },

  /***/
  "./src/decorators/constants.ts":
  /*!*************************************!*\
    !*** ./src/decorators/constants.ts ***!
    \*************************************/

  /*! no static exports found */

  /***/
  function srcDecoratorsConstantsTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.RANGE_KEY = void 0;
    exports.RANGE_KEY = Symbol("validateRangeInt");
    /***/
  },

  /***/
  "./src/decorators/enumberable.ts":
  /*!***************************************!*\
    !*** ./src/decorators/enumberable.ts ***!
    \***************************************/

  /*! no static exports found */

  /***/
  function srcDecoratorsEnumberableTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.enumerable = void 0;
    /**
     * @enumerable decorator that sets the enumerable property of a class field to false.
     * @param value true|false
     */

    function enumerable(value) {
      return function (target, propertyKey) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};

        if (descriptor.enumerable != value) {
          descriptor.enumerable = value;
          descriptor.writable = true;
          Object.defineProperty(target, propertyKey, descriptor);
        }
      };
    }

    exports.enumerable = enumerable;
    /***/
  },

  /***/
  "./src/decorators/index.ts":
  /*!*********************************!*\
    !*** ./src/decorators/index.ts ***!
    \*********************************/

  /*! no static exports found */

  /***/
  function srcDecoratorsIndexTs(module, exports, __webpack_require__) {
    "use strict";

    var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);

      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
          enumerable: true,
          get: function get() {
            return m[k];
          }
        };
      }

      Object.defineProperty(o, k2, desc);
    } : function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      o[k2] = m[k];
    });

    var __exportStar = this && this.__exportStar || function (m, exports) {
      for (var p in m) {
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
      }
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    __exportStar(__webpack_require__(
    /*! ./constants */
    "./src/decorators/constants.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./enumberable */
    "./src/decorators/enumberable.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./ValidateRangeInt */
    "./src/decorators/ValidateRangeInt.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./RangeParameter */
    "./src/decorators/RangeParameter.ts"), exports);
    /***/

  },

  /***/
  "./src/utils/index.ts":
  /*!****************************!*\
    !*** ./src/utils/index.ts ***!
    \****************************/

  /*! no static exports found */

  /***/
  function srcUtilsIndexTs(module, exports, __webpack_require__) {
    "use strict";

    var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);

      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
          enumerable: true,
          get: function get() {
            return m[k];
          }
        };
      }

      Object.defineProperty(o, k2, desc);
    } : function (o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      o[k2] = m[k];
    });

    var __exportStar = this && this.__exportStar || function (m, exports) {
      for (var p in m) {
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
      }
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    __exportStar(__webpack_require__(
    /*! ./wait */
    "./src/utils/wait.ts"), exports);

    __exportStar(__webpack_require__(
    /*! ./isNodeJs */
    "./src/utils/isNodeJs.ts"), exports);
    /***/

  },

  /***/
  "./src/utils/isNodeJs.ts":
  /*!*******************************!*\
    !*** ./src/utils/isNodeJs.ts ***!
    \*******************************/

  /*! no static exports found */

  /***/
  function srcUtilsIsNodeJsTs(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.isNodeJs = void 0;
    var isNodeCache;

    var isNodeJs = function isNodeJs() {
      //@ts-ignore
      //https://stackoverflow.com/a/11918368
      //return typeof module !== 'undefined' && this.module !== module;
      if (isNodeCache === undefined) isNodeCache = typeof self === 'undefined';
      return isNodeCache;
    };

    exports.isNodeJs = isNodeJs;
    /***/
  },

  /***/
  "./src/utils/wait.ts":
  /*!***************************!*\
    !*** ./src/utils/wait.ts ***!
    \***************************/

  /*! no static exports found */

  /***/
  function srcUtilsWaitTs(module, exports, __webpack_require__) {
    "use strict";

    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.wait = void 0;

    var wait = function wait(time) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve();
                  }, time);
                }));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47);
      }));
    };

    exports.wait = wait;
    /***/
  }
  /******/

});